import { Injectable } from '@angular/core';
// import { Headers, Http, RequestOptions, RequestOptionsArgs, Response } from '@angular/http';
// import { AdalService } from 'ng2-adal/dist/core';
import { BehaviorSubject, combineLatest, firstValueFrom, from, lastValueFrom, merge, Observable, of, Subscription, throwError } from 'rxjs';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/observable/of';
// import 'rxjs/add/observable/empty';
// import 'rxjs/add/operator/retry';
import { catchError, map, concat, timeout, debounceTime, flatMap, retryWhen, concatMap, delay, mergeMap, switchMap } from 'rxjs/operators';
import { Flow } from '../obj/Flow';
import { FlowRunAction } from "../obj/FlowRunAction";
// import { StorageService } from './storage.service';
import { FlowRun } from '../obj/FlowRun';
import { ApprovalRequest } from '../obj/ApprovalRequest';
import { Connection } from '../obj/Connection';
import { Settings } from '../flows/settings';
import { MsalService } from '@azure/msal-angular';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// import { decode } from '@angular/router/src/url_tree';
import { MsalHelperService } from './msal-helper.service';
import { AccountInfo } from '@azure/msal-browser';
import { Plan } from '../obj/DeployItem';
import { PowerApp } from '../obj/PowerApp';
import { UserItem, mergeEmails } from './storage-types';
import { FlowLanguageService } from './flow-language.service';
import { StorageRouterService } from './storage-router.service';
import { ContextService } from './context.service';
import { ContextResponse } from '../obj/Context';
import { mapWithConcurrency } from './concurrency.util';
import { isPowerAutomateFlowNotFoundResponse, PowerAutomateBatchRequest, PowerAutomateBatchService } from './power-automate-batch.service';
import { StorageWorkerClientService } from './storage-worker-client.service';
import { FlowStudioBrowserDataCacheService } from './flow-studio-browser-data-cache.service';
import { FlowEventService } from './flow-event.service';
const STORAGE_ENVIRONMENT_KEY = "kunai-environment";
const API_VERSION = "2016-11-01";
const FLOW_STUDIO_DELETED_DETAIL_MARKER = '__flowStudioDeleted';
type FlowApiLicense = 'free' | 'pro' | 'teams' | 'failed';
export interface FlowListPageProbeResult {
    items: any[];
    nextCursor?: string | null;
    total?: number;
}

/**
 * Deprecated server-mediated batching API marker.
 * These FlowStudio proxy paths are disabled, not fallbacks.
 *
 * Set to `true` to force every batch endpoint (`/api/flows`, `/api/flows/meta`,
 * `/api/flows/runs`, `/api/connections`, `/api/makers`) to be skipped, sending
 * the app down the direct-browser path instead. Existing infra/code paths are
 * left intact so flipping this back to `false` restores the feature without a
 * code change.
 *
 * Reason this is currently `true`: concerns about routing user API traffic
 * through the SWA proxy. Browser-only direct calls until that is resolved.
 *
 * When this is `true`:
 *   - The `optionFlowBatchingApi$` subject is locked to `false` on construction
 *     and ignores any subsequent `setBatchingEnabled(true)` call.
 *   - The settings toggle is rendered disabled with explanatory text.
 *   - Stored values from previous sessions (where the user opted in) are
 *     ignored — but not deleted — so re-enabling later restores their choice.
 */
export const FLOW_STUDIO_SERVER_BATCHING_API_DEPRECATED = true;
export const BATCHING_API_FORCE_OFF = false;
// `optionFlowBatchingApi` now means Microsoft's browser-side Power Automate
// batch endpoint. It must not re-enable the deprecated FlowStudio proxy scan
// paths above.

export const groupBy = (xs: any[], key: string) => {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export const distinct = (value: any, index: number, self: any[]) => {
    return self.indexOf(value) === index;
}

export const flatten = (filter: any) => {
    const filters = (filter || {}).filters;
    if (filters) {
        return filters.reduce((acc: any[], curr: any) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
    }
    return [];
};

export const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

@Injectable()
export class FlowManagementService {

    public currentEnvironment$ = new BehaviorSubject<string>('');
    API_ROOT = "https://api.flow.microsoft.com/";
    // API_PA_ROOT = "https://api.powerapps.com/";
    // API_ROOT = "https://management.azure.com/";
    // API_PA_ROOT = "https://management.azure.com/";
    API_PA_ROOT = "https://api.powerapps.com/";

    PROVIDER = "providers/Microsoft.ProcessSimple/";
    PA_PROVIDER = "providers/Microsoft.PowerApps/";
    token_flow_a = null;


    RETRY_LIMIT = 5;

    serviceStatus$ = new BehaviorSubject("");

    // keep all flows we read in memory (including other environments)
    flows$: BehaviorSubject<Flow[]> = new BehaviorSubject<Flow[]>([]);
    // cached$: BehaviorSubject<Flow[]> = new BehaviorSubject([]);
    api = 0;  // 0 azure, 1: api.powerautomate, 2: tenant.powerplatform
    subscription = new Subscription();
    optionApi$: Observable<boolean>;
    /**
     * Live state of the "use FlowStudio batching API" toggle.
     *
     * Kept as a BehaviorSubject (not `from(promise)`) so:
     *   - the timeout-disable handler can flip the flag in-session
     *     without requiring a page reload, and
     *   - the settings toggle can broadcast user changes the same way.
     *
     * Default is `false` (opt-in). Storage is read once at construction;
     * subsequent reads/writes go through this subject.
     */
    optionFlowBatchingApi$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

    private readonly RUNS_RECENT_DAYS = 14;
    private readonly RUNS_HEAVY_ACTIONS_THRESHOLD = 20;
    private readonly RUNS_API_FLOW_CHUNK = 25;
    private readonly RUNS_API_CONCURRENCY = 4;
    private readonly RUNS_API_TOP = 50;
    private readonly RUNS_API_PAGE_LIMIT = 1;
    private readonly FLOW_API_LICENSE_CACHE_MS = 5 * 60 * 1000;
    private flowApiLicenseCache: { username: string; license: FlowApiLicense; expiresAt: number } | null = null;
    private flowApiLicensePromise: Promise<FlowApiLicense> | null = null;

    constructor(
        //private adalService: AdalService,
        //private msalService: MsalService,
        private msalHelperService: MsalHelperService,
        //private http: Http,
        private httpClient: HttpClient,
        // private storageService: StorageService,
        private storageDexieService: StorageRouterService,
        private languageService: FlowLanguageService,
        private contextService: ContextService,
        private powerAutomateBatch: PowerAutomateBatchService,
        private storageWorkerClient: StorageWorkerClientService,
        private browserDataCache: FlowStudioBrowserDataCacheService,
        private flowEventService: FlowEventService,
    ) {
        this.verifyApi();
        this.token_flow_a = this.msalHelperService.getCachedTokenInternal(['https://service.powerapps.com/User']);

        this.optionApi$ = from(this.storageDexieService.getConfig('optionApi').then(value=>{
                        return (value.value !== false);
          }).catch(()=>{
                        return true;
          }));

                // Default ON: batching uses Microsoft's browser-side endpoint.
                // Missing config enables it; an explicit stored false disables it.
                this.storageDexieService.getConfig('optionFlowBatchingApi').then(value => {
                        this.optionFlowBatchingApi$.next(value?.value !== false);
                    }).catch(() => {
                        this.optionFlowBatchingApi$.next(true);
                    });

    }

    /**
     * Persist + broadcast the batching-API toggle. Single chokepoint so any
     * write — settings toggle, timeout self-disable, debug — keeps storage
     * and the in-memory subject in sync.
     *
     * This controls Microsoft's browser-side batch endpoint and does not
     * enable the deprecated FlowStudio `/api/flows` scan path.
     */
    public async setBatchingEnabled(value: boolean): Promise<void> {
        const effective = value !== false;
        try {
            await this.storageDexieService.putConfig('optionFlowBatchingApi', {
                key: 'optionFlowBatchingApi',
                value: effective
            });
        } catch (err) {
            console.warn('[FlowManagementService] failed to persist optionFlowBatchingApi', err);
        }
        this.optionFlowBatchingApi$.next(effective);
    }

    public async log(error?: any): Promise<boolean> {
        if (window.location.hostname == 'localhost') {
            //return;
        }
        try {
            var userName = this.getCurrentUser().username;
            var body: Record<string, any> = {
                "logon": userName,
                "environment": this.currentEnvironment
            };
            if (error) {
                body['error'] = error;
            };

            if (typeof(error) == "string") {
                if (error.indexOf('Token renewal operation failed due to timeout') != -1) {
                    return false;
                }
            }

            var lastLogged = await this.storageDexieService.getConfig(Settings.SETTING_LASTLOGGED);

            if (lastLogged && lastLogged.value && lastLogged.value < (new Date()).getTime() + 15 * 60 * 1000) {
                // don't log twice in 15mins
                return false;
            }

            if (this.currentEnvironment) {
                // only start skipping if user has an environment
                this.storageDexieService.putConfig(
                    Settings.SETTING_LASTLOGGED,
                    { 
                        key: Settings.SETTING_LASTLOGGED, 
                        value: (new Date()).getTime() 
                    });
            }

            if (window.location.hostname != `localhost`) {
                await this.httpClient.post(`https://${window.location.host}/logon`, body).toPromise();
            }
        }
        catch {
            return false;
        }
        return true;
    }

    public async feedback(feedback: string, screenshotDataUrl?: string, attachment?: { content: string; name: string }): Promise<boolean> {
        try {
            var userName = this.getCurrentUser().username;
            await this.httpClient.post('/api/feedback', {
                "logon": userName,
                "feedback": feedback || "",
                ...(screenshotDataUrl ? { "screenshot": screenshotDataUrl } : {}),
                ...(attachment ? { "attachment": attachment } : {})
            }).toPromise();
        }
        catch {
            return false;
        }
        return true;
    }

    // public getToken(): Observable<string> {
    //     return this.adalService.acquireToken(`${API_ROOT}`).pipe(flatMap(
    //         token => token.toString())
    //     );
    // }

    // public hasToken(): boolean {
    //     return !!this.adalService.getCachedToken(`${this.API_ROOT}`);
    // }

    getV2TenantAPI() {
        // get current user
        const { tenantId } = this.getCurrentUser();

        let tenant = tenantId;                    
        tenant = tenant.toLowerCase();
        // Remove all hyphens
        tenant = tenant.replace(/-/g, '');
        // Insert a dot before the last two characters
        tenant = `https://${tenant.slice(0, -2)}.${tenant.slice(-2)}.tenant.api.powerplatform.com/`;
        return tenant;
    }

    getV2EnvironmentAPI(environment: string) {
        let env = environment;
        env = env.toLowerCase();
        // Remove all hyphens
        env = env.replace(/-/g, '');
        // Insert a dot before the last two characters
        env = `https://${env.slice(0, -2)}.${env.slice(-2)}.environment.api.powerplatform.com/`;
        return env;
    }

    async verifyApi() {
        //let setting = await this.storageService.getSetting(Settings.SETTING_USEAPI);
        if (this.api == 0) {
            this.api = 1;
        }

        switch(this.api) {
            case 0:
                //     this.API_ROOT = "https://management.azure.com/";
                //     this.API_PA_ROOT = "https://management.azure.com/";
                //     this.PROVIDER = "providers/Microsoft.ProcessSimple/";
                //     this.PA_PROVIDER = "providers/Microsoft.PowerApps/";
                break;
            case 1:
                this.API_ROOT = "https://api.flow.microsoft.com/";
                //this.API_PA_ROOT = "https://management.azure.com/";
                this.API_PA_ROOT = "https://api.powerapps.com/";
                this.PROVIDER = "providers/Microsoft.ProcessSimple/";
                this.PA_PROVIDER = "providers/Microsoft.PowerApps/";
                /*
                    if (this.currentEnvironment) {
                        this.getEnvironment(this.currentEnvironment).toPromise().then(env=>{
                            this.API_ROOT = `${env.properties.runtimeEndpoints['microsoft.Flow']}/`;
                            this.API_PA_ROOT = `${env.properties.runtimeEndpoints['microsoft.PowerApps']}/`;
                        });
                    }
                */    
                break;
        }


    }

    public set currentEnvironment(environment: string) {
        if (localStorage.getItem(STORAGE_ENVIRONMENT_KEY) != environment) {
            localStorage.setItem(STORAGE_ENVIRONMENT_KEY, environment);
        }

        this.currentEnvironment$.next(environment);
    }

    public get currentEnvironment(): string {
        return localStorage.getItem(STORAGE_ENVIRONMENT_KEY) ?? '';
    }

    public async ensureToken() {
        this.msalHelperService.ensureToken(this.API_ROOT);
    }

    public getEnvironments(): Observable<any> {

        this.serviceStatus$.next("Fetching Environments");

        //let api_root = this.api ? "https://api.flow.microsoft.com/" : "https://management.azure.com/";

        return this.optionApi$.pipe(
            switchMap(optionApi => {
                let requestUrl;
                if (optionApi) {
                    const api_root = this.getV2TenantAPI();
                    const api_version = 1;
                    const api_provider = 'powerautomate/'
                    requestUrl = `${api_root}${api_provider}environments?api-version=${api_version}`;
                }
                else {
                    requestUrl = `${this.API_ROOT}${this.PROVIDER}environments?api-version=${API_VERSION}`;
                }
                return this.sendRequest(requestUrl, {
                    method: "GET"
                })
            }),
            map(environments => {

            // environments.value.filter(env => env.name == this.currentEnvironment).map(env=>{
            //     this.API_ROOT = env.properties.runtimeEndpoints['microsoft.Flow'] + '/';
            //     this.API_PA_ROOT = env.properties.runtimeEndpoints['microsoft.PowerApps'] + '/';
            // });
            // Clear the status string — without this, the footer stays stuck on
            // "Fetching Environments" because no other code path resets it after
            // env discovery completes.
            this.serviceStatus$.next('');
            return environments;
        }));
    }

    public getEnvironment(environment: string): Observable<any> {

        //let api_root = this.api ? "https://api.flow.microsoft.com/" : "https://management.azure.com/";
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}?api-version=${API_VERSION}`, {
            method: "GET"
        }).pipe(timeout(60 * 1000));  // 1min timeout
    }

    public getSolutions(environment: string): Observable<any> {

        return this.getEnvironment(environment).pipe(flatMap(env=>{

            //debugger;
            let flowRoot = env.properties.runtimeEndpoints['microsoft.Flow'] + '/';

            // this end point can only be used to POST
            // return this.sendRequest(`${flowRoot}${this.PROVIDER}environments/${environment}/solutions/beb22393-dc66-e911-a97e-000d3ad1c0d2/flows?api-version=${API_VERSION}`, {
            //     method: "POST"
            // }).pipe(timeout(60 * 1000));  // 1min timeout


            let dynamicsRoot = env.properties.linkedEnvironmentMetadata.instanceApiUrl;

            // https://org9ef703f1.crm6.dynamics.com/api/data/v9.0/solutions?%24expand=publisherid(%24select%3Duniquename%2Cfriendlyname%2Ccustomizationprefix%2Ccustomizationoptionvalueprefix)&%24filter=isvisible%20eq%20true%20or%20endswith(uniquename%2C%20%27_PowerAppsChecker%27)

            // let token = this.msalHelperService.getCachedTokenInternal([`${dynamicsRoot}/user_impersonation`]);

            // debugger;

            let expand = `$expand=publisherid($select=uniquename,friendlyname,customizationprefix,customizationoptionvalueprefix,supportingwebsiteurl,emailaddress,address1_telephone1)`;
            // const t = this.msalHelperService.getCachedTokenInternal([`${dynamicsRoot}/user_impersonation`]);
            // const { secret:token } = t;

            return this.sendRequest(`${dynamicsRoot}/api/data/v9.2/solutions?${expand}&$filter=isvisible eq true`, {
                method: "GET",
                // headers: {
                //     authorization: `Bearer ${token}`
                // }
            }).pipe(map( (res:any)=>{
                return res.value;

            }), timeout(60 * 1000));  // 1min timeout

        }));
    }

    public getSolutionFlows(environment: string, solutionid: string = ''): Observable<any[]> {

        return this.getEnvironment(environment).pipe(
            
            mergeMap(env=>{

                //debugger;
                //let flowRoot = env.properties.runtimeEndpoints['microsoft.Flow'] + '/';

                // this end point can only be used to POST
                // return this.sendRequest(`${flowRoot}${this.PROVIDER}environments/${environment}/solutions/beb22393-dc66-e911-a97e-000d3ad1c0d2/flows?api-version=${API_VERSION}`, {
                //     method: "POST"
                // }).pipe(timeout(60 * 1000));  // 1min timeout


                let dynamicsRoot = env.properties.linkedEnvironmentMetadata.instanceApiUrl;
            //     return dynamicsRoot;
            // }),
            // mergeMap(dynamicsRoot=>{

                // https://org9ef703f1.crm6.dynamics.com/api/data/v9.0/solutions?%24expand=publisherid(%24select%3Duniquename%2Cfriendlyname%2Ccustomizationprefix%2Ccustomizationoptionvalueprefix)&%24filter=isvisible%20eq%20true%20or%20endswith(uniquename%2C%20%27_PowerAppsChecker%27)


                // https://org9ef703f1.crm6.dynamics.com/api/data/v9.0/msdyn_solutioncomponentsummaries?%24filter=(msdyn_solutionid%20eq%20beb22393-dc66-e911-a97e-000d3ad1c0d2)

                // let token = this.msalHelperService.getCachedTokenInternal([`${dynamicsRoot}/user_impersonation`]);
                // const t = this.msalHelperService.getCachedTokenInternal([`${dynamicsRoot}/user_impersonation`]);
                // const { secret:token } = t;

                // debugger;

                // let filter = solutionid ? `$filter=(msdyn_solutionid eq ${solutionid})` : '';
                let filter = `$filter=(msdyn_componenttype eq 29 and msdyn_workflowcategory eq '5')`;
                let expand = `$expand=msdyn_solutionid($select=uniquename,friendlyname,customizationprefix)`;

                return this.sendRequest(`${dynamicsRoot}/api/data/v9.2/msdyn_solutioncomponentsummaries?${filter}`, {
                    method: "GET",
                    // headers: {
                    //     authorization: `Bearer ${token}`
                    // }
                })
            }),
            mergeMap( (res:any)=>{
                const solutionFlows : any[] = res.value.filter((flow: any)=>flow.msdyn_componenttypename == "Process" && flow.msdyn_workflowcategoryname == "Modern Flow");

                const promises = solutionFlows.map((flow)=>{
                    return this.getFlow(environment, flow.msdyn_workflowidunique).pipe(
                        
                        map(raw=>{

                            const flow = new Flow(raw);
                            return flow;
                        })
                    );
                });
                
                // msdyn_workflowidunique
                const ob = combineLatest(promises);

                ob.toPromise().then((flows)=>{
                    return this.browserDataCache.putProductionFlows(flows || [], environment, 'user');
                });

                return ob;
            }), 
            
            timeout(60 * 1000)
            // 1min timeout
        );  
    }

    public createSolutionFlow(environment: string, solutionid: string, flowData: any): Observable<any> {
        //https://australia.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-26e65220-5561-46ef-9783-ce5f20489241/solutions/beb22393-dc66-e911-a97e-000d3ad1c0d2/flows?api-version=2016-11-01
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/solutions/${solutionid}/flows?api-version=${API_VERSION}`, {
            method: "POST",
            body: flowData
        });
    }

    public makeFlowSolutionAware(environment: string, flowNames: string[], solutionid: string) {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/solutions/${solutionid}/migrateFlows?api-version=${API_VERSION}`, {
            method: "POST",
            body: {
                flowsToMigrate: flowNames
            }
        });
    }

    public async scan(environment: string, admin: boolean = false, solution = false) {
        // getTrigger=false: skip listCallbackUrl during initial load to avoid API storm.
        // Trigger URLs are fetched lazily per-flow when actually needed.
        const flows = await this.getFlows(environment, admin, false, false, false, solution);

        // Pre-populate the users table with every flow owner OID we just saw.
        // The records are intentionally minimal (no displayName, no email yet) —
        // putUsers' merge logic preserves any richer data already in storage and
        // accepts later enrichment from getMakers / cacheUsersFromConnections
        // without clobbering empties from this pass.
        this.cacheUsersFromFlows(flows || []).catch((err: any) =>
            console.warn('[FlowManagementService] cacheUsersFromFlows failed', err));

        // Legacy direct scan fetch disabled. Keep this block commented during rollout
        // in case we need to revert to client-side Power Automate enumeration.
        // let requests: Promise<Flow[]>[] = [];
        // // get flows
        // if (admin) {
        //     let adminScope = admin ? 'scopes/admin/' : '';
        //     requests.push(this.getFlowsLoopAdmin(adminScope, environment));
        // }
        // else {
        //     // retry = true;
        //     // retryCount = 0;
        //     // if (prev) {
        //     //     filter = `&$filter=lastModifiedTime gt '${prev}' `;
        //     // }
        //     requests.push(this.getFlowsLoop(environment, solution));
        //     // requestUrl = '';
        //     // nextLink = '';
        //     // retry = true;
        //     requests.push(this.getFlowsLoopTeam(environment, solution));
        //
        //     if (solution) {
        //         requests.push(this.getFlowsLoopDataverse(environment));
        //     }
        // }
        //
        // return Promise.all(requests);

        return [flows];
    }

    public async scanRuns(admin: boolean, environment: string) {
        // scan events?
        // events can only be scanned with appropriate permissions
        // without permissions - revert to scanning via runs

        if (false && this.token_flow_a) {
            const events = this.getEvents2(environment, undefined /*, cached */);
            return events;
        }
        else {
            // without flow impersonation we can't read activity, so switch back to read flows.

            this.serviceStatus$.next(`Preparing to scan runs.`);

            const flows = await ((admin) ? this.browserDataCache.getProductionFlows(environment, 'admin') : this.browserDataCache.getProductionFlows(environment, 'user'));

            const envFlows = (flows || []).filter((f: Flow) => f.environment == environment && !!f.flowName);
            const activeFlows = envFlows.filter((f: Flow) => f.flowState == 'Started');
            console.log(`[scanRuns] admin=${admin} env=${environment} totalFlows=${(flows||[]).length} envFlows=${envFlows.length} activeFlows=${activeFlows.length}`);
            if (activeFlows.length === 0) {
                this.serviceStatus$.next('No active flows found for run scan.');
                return [];
            }

            const cachedRunsRaw = await firstValueFrom(this.storageDexieService.getRuns$(environment) as any);
            const cachedRuns = (Array.isArray(cachedRunsRaw) ? cachedRunsRaw : []) as FlowRun[];
            const cachedRunFlowNames = new Set<string>(cachedRuns.map((r: FlowRun) => `${r.flowName || ''}`.toLowerCase()).filter(Boolean));

            const enabledGroups = await this.getEnabledRunScanGroups();
            const groups = this.buildRunPriorityGroups(activeFlows, cachedRunFlowNames, enabledGroups);
            console.log(`[scanRuns] cachedRuns=${cachedRuns.length} enabledGroups=[${[...enabledGroups].join(',')}] priorityGroups=${groups.length} totalFlowsToScan=${groups.reduce((s,g)=>s+g.flowNames.length,0)}`);
            if (groups.length === 0) {
                this.serviceStatus$.next('No run scan groups are enabled.');
                return [];
            }

            const runs = this.getRunsInGroups(environment, groups, admin).then(()=>{});
            return runs;
        }
    }

    private async getEnabledRunScanGroups(): Promise<Set<string>> {
        const defaultGroups = ['monitored', 'cached-runs', 'queued', 'started-recently-modified', 'started-heavy-actions', 'rest'];
        const setting = await this.storageDexieService.getConfig(Settings.SETTING_RUN_SCAN_GROUPS).catch(() => null);
        const value = setting?.value;
        const groups = Array.isArray(value) ? ['queued', ...value] : defaultGroups;
        return new Set(groups.filter((group) => defaultGroups.includes(group)));
    }

    private splitIntoChunks<T>(values: T[], chunkSize: number): T[][] {
        const chunks: T[][] = [];
        for (let i = 0; i < values.length; i += chunkSize) {
            chunks.push(values.slice(i, i + chunkSize));
        }
        return chunks;
    }

    private reportRunsBatchProgress(id: string, label: string, status: 'running' | 'done' | 'failed' | 'cancelled', completed: number, total: number): void {
        this.flowEventService.reportProgress({
            id,
            group: 'runs',
            label,
            status,
            completed,
            total
        });
    }

    private getRunScanGroupTag(groupLabel: string): string {
        switch (groupLabel) {
            case 'queued':
                return 'queued';
            case 'monitored':
                return 'monitor';
            case 'cached-runs':
                return 'prev-runs';
            case 'started-recently-modified':
                return 'modified';
            case 'started-heavy-actions':
                return 'heavy';
            case 'rest':
                return 'remain';
            case 'selected flow':
                return 'selected';
            default:
                return groupLabel || 'runs';
        }
    }

    private getRunBatchFailureProgressLabel(progressLabel: string, reason: string): string {
        return reason === 'too-many'
            ? `${progressLabel} [too-many, retry in 10 min]`
            : `${progressLabel} [${reason}]`;
    }

    private buildRunPriorityGroups(flows: Flow[], cachedRunFlowNames: Set<string>, enabledGroups: Set<string>) {
        const now = Date.now();
        const recentMs = this.RUNS_RECENT_DAYS * 24 * 60 * 60 * 1000;
        const seen = new Set<string>();

        const uniq = (label: string, items: Flow[]) => {
            if (!enabledGroups.has(label)) {
                return [];
            }
            return (items || []).filter((f: Flow) => {
                const key = (f?.flowName || '').toLowerCase();
                if (!key || seen.has(key)) return false;
                seen.add(key);
                return true;
            });
        };

        const monitored = uniq('monitored', flows.filter((f) => !!f.monitored));

        const hasCachedRuns = uniq('cached-runs', flows.filter((f) => cachedRunFlowNames.has((f.flowName || '').toLowerCase())));

        const queued = uniq('queued', flows.filter((f: any) => !!f.runScanQueuedAt));

        const recentlyModified = uniq('started-recently-modified', flows.filter((f) => {
            if (f.flowState !== 'Started' || !f.modified) return false;
            const modified = new Date(f.modified).getTime();
            return Number.isFinite(modified) && (now - modified) <= recentMs;
        }));

        const heavyAction = uniq('started-heavy-actions', flows.filter((f) => {
            return f.flowState === 'Started' && Number(f.actionsCount || 0) >= this.RUNS_HEAVY_ACTIONS_THRESHOLD;
        }));

        const rest = uniq('rest', flows);

        const groups = [
            { label: 'monitored', flows: monitored },
            { label: 'cached-runs', flows: hasCachedRuns },
            { label: 'queued', flows: queued },
            { label: 'started-recently-modified', flows: recentlyModified },
            { label: 'started-heavy-actions', flows: heavyAction },
            { label: 'rest', flows: rest }
        ];

        return groups
            .map((group) => ({
                label: group.label,
                flowNames: group.flows.map((f) => f.flowName).filter(Boolean)
            }))
            .filter((group) => group.flowNames.length > 0);
    }

    private async getRunsFromApiGroup(environment: string, flowNames: string[], admin: boolean, groupLabel: string, groupIndex: number, groupTotal: number): Promise<FlowRun[]> {
        this.throwFlowStudioProxyDisabled('/api/flows/runs');
    }

    private async getRunsInGroups(environment: string, groups: { label: string; flowNames: string[] }[], admin = false) {
        const all: FlowRun[] = [];
        // Deprecated: never route run scans through FlowStudio `/api/flows/runs`.
        // The setting now controls Microsoft's browser-side batch endpoint.
        const useFlowStudioApi = false;

        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            const chunks = this.splitIntoChunks(group.flowNames, this.RUNS_API_FLOW_CHUNK);

            for (let c = 0; c < chunks.length; c++) {
                const chunk = chunks[c];
                const label = `${group.label}${chunks.length > 1 ? ` (${c + 1}/${chunks.length})` : ''}`;
                const start = c * this.RUNS_API_FLOW_CHUNK + 1;
                const end = start + chunk.length - 1;
                const progressLabel = `Runs [${this.getRunScanGroupTag(group.label)}] batch ${start}-${end}`;
                const progressId = `runs-batch-${group.label}-${start}-${end}`;

                if (!useFlowStudioApi) {
                    this.serviceStatus$.next(`Direct runs scan for ${label}...`);
                    this.reportRunsBatchProgress(progressId, progressLabel, 'running', 0, chunk.length);
                    // Pass through `admin` so admin-scope scans hit the right
                    // upstream URL. (Was hardcoded to false, which dropped
                    // admin context for /admin runs scans.)
                    const legacyRuns = await this.getRunsLegacy(environment, chunk, admin, progressId, progressLabel);
                    all.push(...legacyRuns);
                    continue;
                }

                try {
                    console.log(`[runs] starting group ${i + 1}/${groups.length}: ${label} (${chunk.length} flows)`);
                    const batchRuns = await this.getRunsFromApiGroup(environment, chunk, admin, label, i + 1, groups.length);
                    all.push(...batchRuns);
                    console.log(`[runs] completed group ${i + 1}/${groups.length}: ${label} (${batchRuns.length} runs)`);
                } catch (err: any) {
                    const status = Number(err?.status || err?.error?.status || 0);
                    console.warn(`[runs] group failed: ${label}`, err);

                    // Auth / quota / rate-limit errors won't be fixed by
                    // swapping APIs — stop here so we don't compound the issue.
                    if (status === 401 || status === 402 || status === 403 || status === 429 || this.isPaidRequiredError(err)) {
                        this.serviceStatus$.next(`Stopped run scan after ${label} (HTTP ${status})`);
                        return all;
                    }

                    // This branch is unreachable while the FlowStudio proxy
                    // path is disabled. If someone re-enables it in future,
                    // errors must still switch to direct browser reads.
                    try {
                        this.serviceStatus$.next(`Run scan ${label}: switching to direct browser reads...`);
                        const legacyRuns = await this.getRunsLegacy(environment, chunk, admin, progressId, progressLabel);
                        all.push(...legacyRuns);
                        console.log(`[runs] direct browser read recovered ${legacyRuns.length} runs for ${label}`);
                    } catch (legacyErr) {
                        console.warn(`[runs] direct browser read failed for ${label}`, legacyErr);
                    }
                }
            }
        }

        this.serviceStatus$.next(`Finished fetching runs. (${all.length})`);
        return all;
    }

    private async getRunsLegacy(environment: string, flowNames: string[], admin = false, progressId?: string, progressLabel?: string): Promise<FlowRun[]> {
        const errors: string[] = [];
        const pendingDirect = new Set((flowNames || []).filter(Boolean));
        const total = pendingDirect.size;
        const directProgressId = progressId ? progressId.replace('runs-batch-', 'runs-direct-') : undefined;
        const directProgressLabel = progressLabel ? progressLabel.replace(' batch ', ' direct ') : undefined;
        let batchFailed = false;
        let skipDirectReason: string | null = null;
        let runs: FlowRun[] = [];
        const clearQueued = new Set<string>();

        try {
            this.serviceStatus$.next(`Browser batch runs scan (${pendingDirect.size} flows)...`);
            if (progressId && progressLabel) {
                this.reportRunsBatchProgress(progressId, progressLabel, 'running', 0, total);
            }
            const batchMap = await this.getFlowRunsBatch(environment, [...pendingDirect], admin, this.RUNS_API_TOP);
            const blockedFailures = this.getBlockingRunBatchFailures(batchMap);
            const deletedFlowNames: string[] = [];
            for (const [flowName, batchRuns] of batchMap.entries()) {
                if (admin && this.isDeletedFlowArrayMarker(batchRuns)) {
                    deletedFlowNames.push(flowName);
                    pendingDirect.delete(flowName);
                    clearQueued.add(flowName);
                    if (progressId && progressLabel) {
                        this.reportRunsBatchProgress(progressId, progressLabel, 'running', total - pendingDirect.size, total);
                    }
                    continue;
                }
                runs.push(...batchRuns);
                pendingDirect.delete(flowName);
                clearQueued.add(flowName);
                if (progressId && progressLabel) {
                    this.reportRunsBatchProgress(progressId, progressLabel, 'running', total - pendingDirect.size, total);
                }
            }
            if (blockedFailures.length) {
                skipDirectReason = this.getRunBatchFailureReason(blockedFailures[0]) || 'too-many';
                for (const failure of blockedFailures) {
                    pendingDirect.delete(failure.id);
                }
                await this.queueRunScanFailures(environment, blockedFailures.map((failure) => failure.id), skipDirectReason, blockedFailures[0]?.error || blockedFailures[0]?.statusText);
                if (progressId && progressLabel) {
                    this.reportRunsBatchProgress(progressId, this.getRunBatchFailureProgressLabel(progressLabel, skipDirectReason), 'failed', total - pendingDirect.size, total);
                }
            }
            if (deletedFlowNames.length) {
                await this.markAdminFlowsDeleted(environment, deletedFlowNames);
            }
        } catch (err) {
            skipDirectReason = this.getRunBatchFailureReason(err);
            console.warn(skipDirectReason
                ? `[runs] browser batch runs failed [${skipDirectReason}]; queueing instead of direct retry`
                : '[runs] browser batch runs failed; falling back to direct per-flow runs', err);
            batchFailed = true;
            if (skipDirectReason) {
                await this.queueRunScanFailures(environment, [...pendingDirect], skipDirectReason, this.stringifyRunBatchError(err));
                pendingDirect.clear();
            }
            if (progressId && progressLabel) {
                this.reportRunsBatchProgress(progressId, skipDirectReason ? this.getRunBatchFailureProgressLabel(progressLabel, skipDirectReason) : progressLabel, 'failed', total - pendingDirect.size, total);
            }
        }

        const directTotal = pendingDirect.size;
        if (!batchFailed && !skipDirectReason && directTotal > 0 && progressId && progressLabel) {
            this.reportRunsBatchProgress(progressId, progressLabel, 'done', total - directTotal, total);
        }
        if (directTotal > 0 && directProgressId && directProgressLabel) {
            this.reportRunsBatchProgress(directProgressId, directProgressLabel, 'running', 0, directTotal);
        }

        const perFlow = await mapWithConcurrency([...pendingDirect], async (flowName) => {
            try {
                const flowRuns = await this.getFlowRuns2(environment, flowName, false, false, admin);
                pendingDirect.delete(flowName);
                clearQueued.add(flowName);
                if (directProgressId && directProgressLabel && directTotal > 0) {
                    this.reportRunsBatchProgress(directProgressId, directProgressLabel, 'running', directTotal - pendingDirect.size, directTotal);
                }
                return flowRuns;
            } catch {
                errors.push(flowName);
                pendingDirect.delete(flowName);
                if (directProgressId && directProgressLabel && directTotal > 0) {
                    this.reportRunsBatchProgress(directProgressId, directProgressLabel, 'running', directTotal - pendingDirect.size, directTotal);
                }
                return [] as FlowRun[];
            }
        });

        runs = runs.concat(...perFlow);
        if (directProgressId && directProgressLabel && directTotal > 0) {
            this.reportRunsBatchProgress(directProgressId, directProgressLabel, errors.length ? 'failed' : 'done', directTotal, directTotal);
        } else if (!skipDirectReason && progressId && progressLabel) {
            this.reportRunsBatchProgress(progressId, progressLabel, 'done', total, total);
        }

        console.log(`[getRunsLegacy] admin=${admin} env=${environment} flowCount=${(flowNames||[]).length} runsReturned=${runs.length} errors=${errors.length}`);
        if (clearQueued.size > 0) {
            await this.storageDexieService.clearRunScanQueued(environment, [...clearQueued]).catch((err) => {
                console.warn('[runs] clear queued run-scan flags failed', err);
            });
        }
        if (runs.length > 0) {
            await this.storageDexieService.putRuns(runs);
            console.log(`[getRunsLegacy] putRuns called with ${runs.length} runs`);
        } else {
            console.warn(`[getRunsLegacy] putRuns SKIPPED — no runs returned (errors: ${errors.join(', ')})`);
        }

        if (errors.length > 0) {
            console.warn('[runs] legacy fallback errors:', errors);
        }

        return runs;
    }

    private getBlockingRunBatchFailures(batchMap: Map<string, FlowRun[]>): Array<{ id: string; status?: number; statusText?: string; error?: string }> {
        const failures = ((batchMap as any)?.__failures || []) as Array<{ id: string; status?: number; statusText?: string; error?: string }>;
        return failures.filter((failure) => !!failure?.id && !!this.getRunBatchFailureReason(failure));
    }

    private getRunBatchFailureReason(error: any): string | null {
        const status = this.getRunBatchFailureStatus(error);
        if (status === 401) {
            return 'auth';
        }
        if (status === 403 || status === 429) {
            return 'too-many';
        }
        return null;
    }

    private getRunBatchFailureStatus(error: any): number {
        const direct = Number(error?.status || error?.error?.status || error?.response?.status || 0);
        if (Number.isFinite(direct) && direct > 0) {
            return direct;
        }
        const text = this.stringifyRunBatchError(error);
        const match = text.match(/\b(401|403|429)\b/);
        return match ? Number(match[1]) : 0;
    }

    private stringifyRunBatchError(error: any): string {
        if (!error) return '';
        if (typeof error === 'string') return error;
        return String(error?.message || error?.error?.message || error?.statusText || JSON.stringify(error));
    }

    private async queueRunScanFailures(environment: string, flowNames: string[], reason: string, error?: string): Promise<void> {
        const names = (flowNames || []).filter(Boolean);
        if (!environment || !names.length) return;
        await this.storageDexieService.markRunScanQueued(environment, names, { reason, error }).catch((err) => {
            console.warn('[runs] mark queued run-scan flags failed', err);
        });
    }

    public async getFlowRunsForRoute(environment: string, flowName: string, admin = false): Promise<FlowRun[]> {
        if (!environment || !flowName) {
            return [];
        }
        return this.getRunsInGroups(environment, [{
            label: 'selected flow',
            flowNames: [flowName]
        }], admin);
    }

    // attempt to find the flow's users
    public async scan2(environment: string, admin: boolean = false, solution = false) {

        // this is to find users from flows
        if (admin && !this.token_flow_a) {
            return;
        }

        const license = await this.resolveFlowApiLicense();
        if (admin && this.shouldUseFlowStudioApi(license)) {
            return;
        }

        const flows = await ((admin) ? this.browserDataCache.getProductionFlows(environment, 'admin') : this.browserDataCache.getProductionFlows(environment, 'user'));

        const {tenantId:_tenantId} = this.msalHelperService.user$.getValue();

        // Filter to stale flows in this env so the concurrency cap below
        // applies only to actual external work (no need to spend a slot on
        // flows that early-return null).
        const staleFlows = flows
            .filter((flow) => flow.environment == environment)
            .filter((flow) => flow.scanned == null || flow.scanned < flow.modified);

        const flowsWithOwners = admin
            ? await this.enrichStaleFlowsWithDetails(environment, staleFlows, admin)
            : [];

        const flowsToUpdate = flowsWithOwners.filter((flow): flow is Flow => !!flow);
        if (flowsToUpdate.length > 0) {
            this.browserDataCache.putProductionFlows(flowsToUpdate, environment, admin ? 'admin' : 'user');
        }

        // filter unique users
        const _users = await this.storageDexieService.getUsers();

        const users = flowsWithOwners
            .filter((flow): flow is Flow => flow != null && flow.owners != null)
            .map((flow)=>flow.owners.filter((owner)=>{
                return owner.properties['permissionType'] == 'Principal' &&
                owner.properties['principal'] && owner.properties['principal'].type == "User"
            }).map((owner)=>{

                let { id, tenantId } = owner.properties['principal'];

                if (!tenantId) {
                    tenantId = _tenantId;
                }

                return `${tenantId}.${id}`                
            }))
            .reduce((acc, curr)=>acc.concat(curr), [])
            .filter(distinct);

        // scan and add users to storage service

        // for users not already in storage,


        // Per-user Graph fan-out, capped via the central helper. Already-cached
        // users short-circuit synchronously and don't consume a worker slot's
        // network round-trip.
        const usersToAdd = await mapWithConcurrency(users, async (user): Promise<UserItem> => {
            const [, userId] = user.split('.');
            const storedUser = _users.find((u) => u.key == user);
            if (storedUser) return storedUser;
            try {
                const res = await this.getUser(userId);
                return {
                    key: user,
                    displayName: res.displayName,
                    email: res.mail,
                } as UserItem;
            } catch {
                return { key: user, displayName: '', email: '' } as UserItem;
            }
        });
        this.storageDexieService.putUsers(usersToAdd);
    }

    public getFlows$(environment: string, admin: boolean = false, getRuns: boolean = false, useCache = true, getTrigger = true, getSolution = false): Observable<Flow[]> {
        return from(this.getFlows(environment, admin, getRuns, useCache, getTrigger, getSolution));
    }

    private toFlowRaw(item: any, environment: string): any {
        if (item?.properties) {
            return item;
        }

        const triggerType = item?.triggerType || '';
        const triggerKind = item?.triggerKind || '';

        return {
            _sources: item?._sources ?? (item?._source ? [item._source] : []),
            name: item?.name || item?.RowKey,
            properties: {
                displayName: item?.displayName || '',
                state: item?.state || '',
                flowSuspensionReason: item?.flowSuspensionReason || '',
                lastModifiedTime: item?.lastModifiedTime || null,
                sharingType: item?.sharingType || '',
                environment: {
                    name: item?.environmentName || environment
                },
                definitionSummary: {
                    description: item?.description || '',
                    actions: [],
                    triggers: [
                        {
                            type: triggerType,
                            kind: triggerKind,
                            api: {
                                properties: {
                                    displayName: triggerType,
                                    iconUri: ''
                                }
                            },
                            metadata: {
                                flowSystemMetadata: {
                                    swaggerOperationId: triggerKind
                                }
                            }
                        }
                    ]
                },
                connectionReferences: {},
                creator: {
                    objectId: item?.createdById || null,
                    displayName: item?.ref_createdBy?.displayName || null
                },
                workflowEntityId: item?.workflowEntityId || null,
                owners: item?.owners || [],
                userType: item?.userType || 'Owner',
                definition: item?.actions ? { actions: item.actions } : undefined
            }
        };
    }

    private async getFlowsFromUnifiedApi(environment: string, admin: boolean): Promise<Flow[]> {
        this.throwFlowStudioProxyDisabled('/api/flows');
    }

    private async getApiHeaders(admin: boolean): Promise<{ tokenSecret: string; headers: Record<string, string>; workspace: string } | null> {
        const tokenSecret = await this.getPowerAutomateTokenSecret(admin);
        if (!tokenSecret) return null;
        const workspace = (localStorage.getItem('workspace') || '').trim();
        const headers: Record<string, string> = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${tokenSecret}`,
            'x-authorization': `Bearer ${tokenSecret}`
        };
        if (workspace) headers['x-workspace'] = workspace;
        return { tokenSecret, headers, workspace };
    }

    private subscriptionHasLicense(subscription: any, field: 'license_pro' | 'license_teams'): boolean {
        const licenses = Array.isArray(subscription?.licenses) ? subscription.licenses : [];
        const users = Array.isArray(subscription?.users) ? subscription.users : [];
        return [...licenses, ...users].some((item: any) => !!item?.[field]);
    }

    private getFlowApiLicenseFromSubscription(subscription: any): FlowApiLicense {
        if (this.subscriptionHasLicense(subscription, 'license_teams')) {
            return 'teams';
        }
        if (this.subscriptionHasLicense(subscription, 'license_pro')) {
            return 'pro';
        }

        const status = `${subscription?.membership?.status || ''}`.toLowerCase();
        if (['trial', 'active', 'enterprise'].includes(status)) {
            return 'pro';
        }

        return 'free';
    }

    private getFlowApiLicenseFromContext(context: ContextResponse | null): FlowApiLicense {
        if (!context) {
            return 'failed';
        }

        if (context.hasTeamsEntitlement) {
            return 'teams';
        }

        const plan = `${context.entitlement?.plan || ''}`.toLowerCase();
        const status = `${context.entitlement?.status || ''}`.toLowerCase();
        if ((plan.includes('pro') || plan === 'teams' || plan === 'governance') &&
            ['active', 'trialing', 'trial', 'enterprise'].includes(status)) {
            return 'pro';
        }

        return 'free';
    }

    private strongestFlowApiLicense(values: FlowApiLicense[]): FlowApiLicense {
        if (values.includes('teams')) {
            return 'teams';
        }
        if (values.includes('pro')) {
            return 'pro';
        }
        if (values.includes('free')) {
            return 'free';
        }
        return 'failed';
    }

    private async resolveFlowApiLicense(): Promise<FlowApiLicense> {
        const username = (this.getCurrentUser()?.username || '').toLowerCase();
        const now = Date.now();
        if (this.flowApiLicenseCache &&
            this.flowApiLicenseCache.username === username &&
            this.flowApiLicenseCache.expiresAt > now) {
            return this.flowApiLicenseCache.license;
        }

        if (this.flowApiLicensePromise) {
            return this.flowApiLicensePromise;
        }

        this.serviceStatus$.next('Checking FlowStudio license...');
        this.flowApiLicensePromise = Promise.allSettled([
            firstValueFrom(this.getSubscription(true)),
            this.contextService.load()
        ]).then(([subscriptionResult, contextResult]) => {
            const licenses: FlowApiLicense[] = [];
            if (subscriptionResult.status === 'fulfilled') {
                licenses.push(this.getFlowApiLicenseFromSubscription(subscriptionResult.value));
            } else {
                console.warn('[FlowManagementService] subscription license check failed', subscriptionResult.reason);
                licenses.push('failed');
            }

            if (contextResult.status === 'fulfilled') {
                licenses.push(this.getFlowApiLicenseFromContext(contextResult.value));
            } else {
                console.warn('[FlowManagementService] context license check failed', contextResult.reason);
                licenses.push('failed');
            }

            const license = this.strongestFlowApiLicense(licenses);
            this.flowApiLicenseCache = {
                username,
                license,
                expiresAt: Date.now() + this.FLOW_API_LICENSE_CACHE_MS
            };
            return license;
        }).catch((err) => {
            console.warn('[FlowManagementService] all license checks failed before flow API selection', err);
            this.flowApiLicenseCache = {
                username,
                license: 'failed',
                expiresAt: Date.now() + 30 * 1000
            };
            return 'failed' as FlowApiLicense;
        }).finally(() => {
            this.flowApiLicensePromise = null;
        });

        return this.flowApiLicensePromise;
    }

    private shouldUseFlowStudioApi(license: FlowApiLicense): boolean {
        return license === 'pro' || license === 'teams';
    }

    private throwFlowStudioProxyDisabled(endpoint: string): never {
        throw new Error(`FlowStudio proxy endpoint ${endpoint} is disabled for scans because it is not region reliable.`);
    }

    private async getFlowsFromApi(environment: string, admin: boolean, includeRunSummary: boolean = true): Promise<Flow[]> {
        this.throwFlowStudioProxyDisabled('/api/flows');
        const ctx = await this.getApiHeaders(admin);
        if (!ctx) throw new Error('Missing Power Automate access token for /api/flows');

        // The server picks v1 vs v2 host based on `options`. Mirrors the
        // client's `optionApi` setting (default true on cold cache → V2).
        const useV2 = await firstValueFrom(this.optionApi$);

        // 120s timeout — if the server-mediated /api/flows can't drain all
        // pages in 120s on a cold cache (large /admin envs), the catch in
        // `getFlows()` flips `optionFlowBatchingApi=false` and falls back to
        // the direct legacy path. See docs/plan-api-flows-pagination.md for
        // the longer-term continuation-token alternative we deferred.
        const response: any = await firstValueFrom(
            this.httpClient.post('/disabled-api-flows', {
                environment,
                sources: admin ? ['admin'] : ['my/shared', 'graphql'],
                select: includeRunSummary ? ['run-summary'] : [],
                options: useV2 ? ['V2'] : [],
                ...(ctx.workspace ? { workspace: ctx.workspace } : {})
            }, { headers: new HttpHeaders(ctx.headers) }).pipe(timeout(120 * 1000))
        );

        const values = (response?.flows || []) as any[];
        return values.filter((item) => item?.displayName).map((item) => new Flow(this.toFlowRaw(item, environment)));
    }

    private async enrichFlows(environment: string, admin: boolean, flows: Flow[], includeTriggerUrl: boolean, includeOwners: boolean): Promise<void> {
        const flowsNeedingTrigger = includeTriggerUrl
            ? flows.filter(f => this.isHttpRequestTrigger(f) && !f.triggerUrl && f.flowState !== 'Deleted')
            : [];
        const flowsNeedingOwners = includeOwners
            ? flows.filter(f => !f.owners?.length && f.flowState !== 'Deleted')
            : [];

        const namesToEnrich = [...new Set([
            ...flowsNeedingTrigger.map(f => f.flowName),
            ...flowsNeedingOwners.map(f => f.flowName)
        ])];

        if (namesToEnrich.length === 0) return;

        // Honour the batching toggle. When enabled, enrichment tries
        // Microsoft's browser-side batch endpoint before per-flow fallback.
        const batchingEnabled = this.optionFlowBatchingApi$.getValue();
        await this.enrichFlowsDirect(environment, admin, flows, namesToEnrich, batchingEnabled);
    }

    /**
     * Direct-browser enrichment fallback. Calls `getFlow()` per flow name
     * (one Power Automate request each) to extract `triggerUrl` and `owners`.
     * Admin flows that come back 404 FlowNotFound are marked Deleted. Concurrency is capped via
     * the central `mapWithConcurrency` helper — see `concurrency.util.ts`.
     */
    private async enrichFlowsDirect(environment: string, admin: boolean, flows: Flow[], names: string[], preferBatch = true): Promise<void> {
        if (!names.length) return;
        const purged: Flow[] = [];
        const pendingDirect = new Set(names);

        if (preferBatch) try {
            const details = await this.getFlowsBatch(environment, names, admin);
            for (const [name, item] of details.entries()) {
                const target = flows.find(f => f.flowName === name);
                if (!target) continue;
                if (admin && this.isDeletedFlowDetailMarker(item)) {
                    this.markFlowDeleted(target);
                    purged.push(target);
                    pendingDirect.delete(name);
                    continue;
                }
                const props = item?.properties || {};
                const triggerUri = props.flowTriggerUri as string | undefined;
                const owners = props.owners as any[] | undefined;
                if (triggerUri) target.triggerUrl = triggerUri;
                if (owners?.length) target.owners = owners;
                pendingDirect.delete(name);
            }
        } catch (err) {
            console.warn('[FlowManagementService] batch enrichment failed; falling back to direct per-flow enrichment', err);
        }

        await mapWithConcurrency([...pendingDirect], async (name) => {
            const target = flows.find(f => f.flowName === name);
            if (!target) return;
            try {
                const item: any = await firstValueFrom(this.getFlow(environment, name, admin).pipe(timeout(60 * 1000)));
                const props = item?.properties || {};
                const triggerUri = props.flowTriggerUri as string | undefined;
                const owners = props.owners as any[] | undefined;
                if (triggerUri) target.triggerUrl = triggerUri;
                if (owners?.length) target.owners = owners;
            } catch (err: any) {
                const status = Number(err?.status || err?.error?.status || 0);
                const code = String(err?.error?.error?.code || err?.error?.code || '');
                if (admin && status === 404 && code === 'FlowNotFound') {
                    this.markFlowDeleted(target);
                    purged.push(target);
                }
                // Other errors: silently skip — enrichment is additive.
            }
        });

        if (purged.length) {
            await this.browserDataCache.putProductionFlows(purged, environment, admin ? 'admin' : 'user');
        }
    }

    private async enrichStaleFlowsWithDetails(environment: string, flows: Flow[], admin: boolean): Promise<Array<Flow | null>> {
        const result: Array<Flow | null> = [];
        const pendingDirect = new Set(flows.map((flow) => flow.flowName).filter(Boolean));

        try {
            const details = await this.getFlowsBatch(environment, [...pendingDirect], admin);
            for (const flow of flows) {
                const item = details.get(flow.flowName);
                if (!item) continue;
                if (admin && this.isDeletedFlowDetailMarker(item)) {
                    this.markFlowDeleted(flow);
                    result.push(flow);
                    pendingDirect.delete(flow.flowName);
                    continue;
                }
                if (this.applyFlowDetailToCachedFlow(flow, item)) {
                    result.push(flow);
                }
                pendingDirect.delete(flow.flowName);
            }
        } catch (err) {
            console.warn('[FlowManagementService] batch scan2 detail enrichment failed; falling back to direct per-flow requests', err);
        }

        const direct = await mapWithConcurrency([...pendingDirect], async (name): Promise<Flow | null> => {
            const flow = flows.find((candidate) => candidate.flowName === name);
            if (!flow) return null;
            try {
                const item: any = await firstValueFrom(this.getFlow(flow.environment, flow.flowName, admin));
                return this.applyFlowDetailToCachedFlow(flow, item) ? flow : null;
            } catch (err: any) {
                const status = Number(err?.status || err?.error?.status || 0);
                const code = String(err?.error?.error?.code || err?.error?.code || '');
                if (admin && status === 404 && code === 'FlowNotFound') {
                    this.markFlowDeleted(flow);
                    return flow;
                }
                return null;
            }
        });
        result.push(...direct);
        return result;
    }

    private applyFlowDetailToCachedFlow(flow: Flow, item: any): boolean {
        if (!item?.properties?.definitionSummary) {
            return false;
        }
        flow.description = item.properties.definitionSummary.description;
        if (item.properties.definitionSummary?.triggers) {
            flow.resolveTriggers(item.properties.definitionSummary, item.properties.connectionReferences);
        }
        flow.scanned = new Date();
        return true;
    }

    private async getFlowsFromLegacyActions(environment: string, admin: boolean, getSolution: boolean): Promise<Flow[]> {
        if (admin) {
            const adminScope = 'scopes/admin/';
            return this.getFlowsLoopAdmin(adminScope, environment);
        }

        const requests: Promise<Flow[]>[] = [
            this.getFlowsLoop(environment, getSolution),
            this.getFlowsLoopTeam(environment, getSolution)
        ];

        if (getSolution) {
            requests.push(this.getFlowsLoopDataverse(environment).then((flows)=>flows || []));
        }

        const batches = await Promise.all(requests);
        return batches.reduce((acc, batch)=>acc.concat(batch || []), [] as Flow[]);
    }

    private async getFlowsFromWorkerListing(environment: string, admin: boolean, getSolution: boolean): Promise<Flow[] | null> {
        const token = await this.getPowerAutomateBatchToken(admin);
        if (!token?.secret) {
            console.warn('[FlowManagementService] worker flow listing skipped: missing token', { admin });
            return null;
        }

        const scanId = uuidv4();
        const optionApi = await firstValueFrom(this.optionApi$);
        try {
            console.log('[FlowManagementService] worker flow listing start', {
                scanId,
                environment,
                admin,
                optionApi,
                getSolution
            });
            const result = admin
                ? await this.storageWorkerClient.scanAdminFlows({
                    scanId,
                    mode: 'admin',
                    environment,
                    apiRoot: this.API_ROOT,
                    provider: this.PROVIDER,
                    includeSolution: getSolution,
                    auth: {
                        powerAppsBearerToken: token.secret,
                    },
                })
                : await this.storageWorkerClient.scanFlows({
                    scanId,
                    mode: 'flows',
                    environment,
                    apiRoot: this.API_ROOT,
                    provider: this.PROVIDER,
                    useV2: optionApi,
                    v2ApiRoot: optionApi ? this.getV2EnvironmentAPI(environment) : undefined,
                    includeSolution: getSolution,
                    auth: {
                        flowBearerToken: token.secret,
                    },
                });

            if (!result?.accepted || result.status !== 'completed') {
                console.warn('[FlowManagementService] worker flow listing not accepted', result);
                return null;
            }

            const flows = (result.flows || []).map((item) => Object.assign(new Flow(), item));
            console.log('[FlowManagementService] worker flow listing completed', {
                scanId,
                environment,
                admin,
                count: flows.length
            });
            return flows;
        } catch (error) {
            console.warn('[FlowManagementService] worker flow listing failed; using main-thread listing', error);
            return null;
        }
    }

    private isPaidRequiredError(err: any): boolean {
        return err?.status === 402 ||
            err?.error?.error === 'paid_required' ||
            err?.error?.jsonBody?.error === 'paid_required';
    }

    private isTimeoutError(err: any): boolean {
        // RxJS `timeout()` raises an Error with name 'TimeoutError'.
        // Some HTTP layers also surface 504 (gateway timeout) / 408.
        return err?.name === 'TimeoutError' ||
            err?.constructor?.name === 'TimeoutError' ||
            err?.status === 504 ||
            err?.status === 408;
    }

    private isHttpRequestTrigger(flow: Flow): boolean {
        const triggerType = (flow?.trigger || '').toLowerCase();
        const triggerKind = (flow?.triggerKind || '').toLowerCase();
        return triggerType === 'request' && triggerKind === 'http';
    }

    private shouldFetchTriggerUrl(flow: Flow): boolean {
        return this.isHttpRequestTrigger(flow) && !flow.triggerUrl && flow.flowState != 'Deleted';
    }

    /**
     * @param runStaleProbe  Default true. When the unified API path is used,
     *   we batch-call /api/flows/runs for every flow whose `scanned` timestamp
     *   is older than 3 days, so deleted flows get marked Purged. Callers that
     *   only need the flow list (e.g. /zip exporter) should pass false to skip
     *   the runs traffic — they don't care about purge detection.
     */
    public async getFlows(environment: string, admin: boolean = false, getRuns: boolean = false, useCache = true, getTrigger = true, getSolution = false, runStaleProbe: boolean = true, includeRunSummary: boolean = true, hydrateFromCache: boolean = true): Promise<Flow[]> {

        let filter = '';
        var prev = null;
        this.serviceStatus$.next(`Loading flows for ${environment.split('(')[0].trim()}...`);

        let cacheFlows : Flow[] = [];

        useCache = false;
        /*
        if (useCache == true) {
            cacheFlows = await this.storageService.getFlows(environment);
            if (cacheFlows.length > 0) {
                cacheFlows.sort((a, b) => {
                    return (b.modified ? b.modified.getTime() : 0) - (a.modified ? a.modified.getTime() : 0);
                });
                prev = cacheFlows[0].modified.toISOString();

                this.serviceStatus$.next(`Reading ${cacheFlows.length} cached Flows`);
                // can't get this $filter to work
                // filter = `&$expand=properties
                //filter = `&$filter=properties/lastModifiedTime gt '${prev}' `;
            }
        }
        */

        // Deprecated: never route flow listing through FlowStudio `/api/flows`.
        // Listings stay sequential/direct; the batching toggle now controls
        // Microsoft's browser-side batch endpoint for per-flow follow-up reads.
        const useFlowStudioApi = false;

        let unifiedFlows: Flow[] = [];
        let usedBatchingPayload = false;
        if (useFlowStudioApi) {
            try {
                this.serviceStatus$.next('Fetching flows from server...');
                unifiedFlows = await this.getFlowsFromApi(environment, admin, includeRunSummary);
                usedBatchingPayload = true;
                this.serviceStatus$.next(`Received ${unifiedFlows.length} flows`);

                // Restore cached fields (e.g. triggerUrl) from OPFS before deciding what to enrich.
                // Definition-only search calls can skip this because old caches may contain
                // oversized flow JSON from previous builds, and parsing those blobs can freeze
                // the browser before the refresh request completes.
                if (hydrateFromCache) {
                    // Admin scans must hydrate from the admin table — non-admin scans from the user table.
                    const opfsFlows = await this.browserDataCache.getProductionFlows(environment, admin ? 'admin' : 'user');
                    this.hydrate(unifiedFlows, opfsFlows);
                }

                // Early persist: write flows to OPFS now so the UI table populates
                // immediately, BEFORE the slow trigger-URL enrichment and stale-probe
                // (which can take ~2 minutes on cold cache for environments with
                // hundreds of admin flows). Final `stasis` at the end of getFlows
                // still writes any enrichments those later steps produce.
                if (unifiedFlows.length > 0) {
                    await this.browserDataCache.putProductionFlows(unifiedFlows, environment, admin ? 'admin' : 'user')
                        .catch((err) => console.warn('[FlowManagementService] early putFlows failed', err));
                }

                // Enrich only flows that still need a trigger URL (client decides, server just fetches)
                if (getTrigger) {
                    const needCount = unifiedFlows.filter(f => this.shouldFetchTriggerUrl(f)).length;
                    if (needCount > 0) {
                        this.serviceStatus$.next(`Fetching trigger URLs for ${needCount} flows...`);
                        await this.enrichFlows(environment, admin, unifiedFlows, true, false);
                    }
                }

                // Stale probe: flows not confirmed alive in >3 days get a runs check.
                // This must not use the server-side `/api/flows/runs` endpoint
                // (via getRuns → getRunsInGroups → getRunsFromApiGroup) instead of
                // It should use browser-side Microsoft batch/direct reads only.
                // Skipped when `runStaleProbe=false` — definition-only callers (e.g.
                // /search) don't need purge detection and shouldn't pay the runs cost.
                if (runStaleProbe) {
                    const threeDaysAgo = new Date(Date.now() - 3 * 24 * 60 * 60 * 1000);
                    const stale = unifiedFlows.filter(f =>
                        f.flowState !== 'Deleted' && f.flowState !== 'Purged' &&
                        (!f.scanned || f.scanned < threeDaysAgo)
                    );
                    if (stale.length > 0) {
                        this.serviceStatus$.next(`Checking ${stale.length} stale flows...`);
                        try {
                            await this.getRuns(environment, stale.map((f) => f.flowName), admin);
                        } catch (err) {
                            console.warn('[FlowManagementService] stale-probe getRuns failed', err);
                        }
                    }
                }
            } catch (err) {
                if (this.isPaidRequiredError(err)) {
                    this.serviceStatus$.next('FlowStudio API requires a paid plan.');
                    unifiedFlows = [];
                } else if (this.isTimeoutError(err)) {
                    // Disabled /api/flows branch timed out.
                    // on a large env. Persist `optionFlowBatchingApi=false` so
                    // future navigations skip the slow path, and fall through
                    // to the direct legacy listing for this call. See
                    // docs/plan-api-flows-pagination.md for the deferred
                    // continuation-token alternative.
                    console.warn('[FlowManagementService] disabled /api/flows path timed out; using direct listing', err);
                    this.serviceStatus$.next('Switching to direct API...');
                    // setBatchingEnabled persists AND pushes to the subject so
                    // every subsequent batch call site (runs, meta, connections,
                    // makers) immediately picks up the disabled state.
                    unifiedFlows = await this.getFlowsFromLegacyActions(environment, admin, getSolution);
                    this.serviceStatus$.next(`Received ${unifiedFlows.length} flows (direct)`);
                    usedBatchingPayload = false;
                } else {
                    // Any other failure: fall back to direct legacy listing rather
                    // than leaving the user staring at an empty grid. Same path as
                    // the timeout branch, minus the persisted flag flip.
                    console.warn('[FlowManagementService] disabled /api/flows path failed; using direct listing', err);
                    this.serviceStatus$.next('Switching to direct API...');
                    try {
                        unifiedFlows = await this.getFlowsFromLegacyActions(environment, admin, getSolution);
                        this.serviceStatus$.next(`Received ${unifiedFlows.length} flows (direct)`);
                    } catch (legacyErr) {
                        console.warn('[FlowManagementService] direct listing failed', legacyErr);
                        this.serviceStatus$.next('Could not fetch flows.');
                        unifiedFlows = [];
                    }
                    usedBatchingPayload = false;
                }
            }
        } else {
            this.serviceStatus$.next('Fetching flows in worker...');
            unifiedFlows = await this.getFlowsFromWorkerListing(environment, admin, getSolution) || [];
            if (unifiedFlows.length > 0) {
                this.serviceStatus$.next(`Received ${unifiedFlows.length} flows`);
            } else {
                this.serviceStatus$.next('Fetching flows (legacy API)...');
                unifiedFlows = await this.getFlowsFromLegacyActions(environment, admin, getSolution);
                this.serviceStatus$.next(`Received ${unifiedFlows.length} flows`);
            }
        }

        // Legacy fallback disabled. Keep this block commented during rollout in case
        // direct Power Automate calls are needed again for troubleshooting.
        // else if (admin) {
        //
        //     let adminScope = admin ? 'scopes/admin/' : '';
        //     flowRequests.push(this.getFlowsLoopAdmin(adminScope, environment));
        //
        //
        // }
        // else {
        //
        //     // retry = true;
        //     // retryCount = 0;
        //     // if (prev) {
        //     //     filter = `&$filter=lastModifiedTime gt '${prev}' `;
        //     // }
        //
        //     flowRequests.push(this.getFlowsLoop(environment, getSolution));
        //
        //     // requestUrl = '';
        //     // nextLink = '';
        //     // retry = true;
        //     flowRequests.push(this.getFlowsLoopTeam(environment, getSolution));
        // }

        var flows = unifiedFlows;

        // debugger
        this.hydrate(flows, cacheFlows);

        let newFlows: Flow[] = flows;
        /*
        if (prev) {
            newFlows = flows.filter(item => item.modified.toISOString() > prev);
        }
        else {
            newFlows = flows;
        }
        */

        if (cacheFlows.length > 0) {
            let deletedFlows = cacheFlows.filter(item => {
                return item.flowState == "Deleted";
            });
            //var deletedFlows = [];

            // cacheFlows = cacheFlows.filter(item => {
            //     return flows.filter(flow => flow.flowName == item.flowName).length > 0;
            // });

            cacheFlows.map( (item:Flow) => {
                let newF = flows.filter(flow => flow.flowName == item.flowName);
                if (newF.length > 0) {
                    if (
                      item.trigger != newF[0].trigger ||
                      item.triggerKind != newF[0].triggerKind ||
                      item.displayName != newF[0].displayName ||
                      item.flowState != newF[0].flowState) {
                        //item.triggers = newF[0].triggers;
                        newFlows.push(newF[0]);
                        return true;
                    }
                    // if (item._actions == null || item._actions.length == 0) {
                    //     newFlows.push(newF[0]);
                    //     return true;
                    // }
                }
                return false;
            });

            // cacheFlows = cacheFlows.filter(item=>{
            //     return newFlows.filter(flow=>flow.flowName == item.flowName).length == 0
            // });
            if (!admin && deletedFlows && deletedFlows.length) {
                await this.storageDexieService.removeFlows(deletedFlows);
                //await this.storageService.removeFlows(deletedFlows);
            }
        }

        var pWaits: Promise<any>[] = [];
        let deleted: Flow[] = [];
        if (getTrigger && !usedBatchingPayload){
            const triggerCount = newFlows.filter(f => !this.isHttpRequestTrigger(f) ? false : this.shouldFetchTriggerUrl(f)).length;
            if (triggerCount > 0) {
                this.serviceStatus$.next(`Fetching trigger URLs for ${triggerCount} flows...`);
            }
            newFlows.forEach(flow => {
                if (!admin && this.shouldFetchTriggerUrl(flow)) {
                    var p = this.getFlowTriggerUrl(environment, flow.flowName).then(url => {
                        flow.triggerUrl = url;
                    }).catch(res => {
                        // if (res.error && res.error.error && res.error.error.code == "FlowNotFound") {
                        // 'new' flows aren't likely to have this check
                        //     flow.flowState = "Deleted";
                        // }
                        if (res.error && res.status == 404 && res.error.error && res.error.error.code == "AzureResourceManagerRequestFailed") {
                            // flow deleted
                            flow.flowState = "Deleted";
                            deleted.push(flow);
                        }
                        return true;
                    });
                    pWaits.push(p);
                }
            });

        }

        if (pWaits.length > 0) {
            this.serviceStatus$.next(`Waiting for ${pWaits.length} background requests...`);
        }

        if (getRuns) {
            this.serviceStatus$.next(`Fetching Flow Runs`);


            ([...newFlows, ...cacheFlows]).forEach((flow: Flow) => {

                // var runs = cachedRuns.filter((run) => { return run.flowName == flow.flowName; });
                // if (runs.length) {
                //     flow.runs.push(...runs);
                // }

                //if (flow.checkRuns > -5) {
                //if ( (flow.nextScanTick || 0) < Date.now()) {
                if (!usedBatchingPayload && flow.flowState != "" && flow.more) {
                    let pRuns = this.getFlowRuns(flow).then(runs => {
                        // if (runs.length == 0) {
                        //     flow.checkRuns = flow.checkRuns -1; // update
                        // }
                        // else {
                        //     flow.checkRuns = 0;
                        // }
                        //newFlows.push(flow);
                    }).catch(reason => { flow.loading = false; });

                    pWaits.push(pRuns);

                }
            });
        }

        // fix old cached flows
        if (getTrigger && !usedBatchingPayload) {
            cacheFlows.filter((f: Flow) => this.shouldFetchTriggerUrl(f)).forEach(flow => {
                var p = this.getFlowTriggerUrl(environment, flow.flowName).then(url => {
                    flow.triggerUrl = url;

                    // save this
                    newFlows.push(flow);
                }).catch(res => {
                    if (res.error && res.error.error && res.error.error.code == "FlowNotFound") {
                        flow.flowState = "Deleted";
                        newFlows.push(flow);
                    }
                    return true;
                });
                pWaits.push(p);
            });
        }
        /*
        cacheFlows.filter((f: Flow) => f.actionsCount == 0).forEach((flow: Flow) => {
            var p = this.getFlow(environment, flow.flowName, admin).toPromise().then(f => {
                flow.resolveActions(f.properties.definitionSummary.actions);
                newFlows.push(flow);
            });
            pWaits.push(p);
        });
        cacheFlows.filter((f: Flow) => !!f.raw).forEach((flow: Flow) => {
            flow.raw = null;
            newFlows.push(flow);
        });
        */

        // var missingApis = [];
        // var pMissingApisFlow = [];

        if (getTrigger && !usedBatchingPayload) {
            newFlows.filter(f => !f.trigger).forEach(flow => {
                var p = this.getFlow(environment, flow.flowName, admin).toPromise().then(f => {
                    flow.resolveTriggers(f.properties.definitionSummary, f.properties.connectionReferences);
                    return this.storageDexieService.putFlow(flow, admin);
                }).catch((reason)=>{

                });
                pWaits.push(p);
            });
            cacheFlows.filter(f => !f.trigger).forEach(flow => {
                var p = this.getFlow(environment, flow.flowName, admin).toPromise().then(f => {
                    flow.resolveTriggers(f.properties.definitionSummary, f.properties.connectionReferences);
                    return this.storageDexieService.putFlow(flow, admin);
                }).catch((reason)=>{

                });
                pWaits.push(p);
            });
        }

        // debugger;
        await Promise.all(pWaits);

        if (!admin && deleted.length > 0) {
            await this.storageDexieService.removeFlows(deleted);
        }
        // debugger;
        if (/*admin ||*/ !useCache) {
          newFlows = newFlows.filter((value,index,self)=>{
              return self.findIndex( v1 => v1.flowName == value.flowName) === index;
          });
          if (newFlows.length) {
              this.stasis(newFlows, cacheFlows, admin);
          }
          this.flows$.next(newFlows);
          return newFlows;
        }

        newFlows = newFlows.filter((value,index,self)=>{
            return self.findIndex( v1 => v1.flowName == value.flowName) === index;
        });

        if (newFlows.length) {
            this.stasis(newFlows, cacheFlows, admin);
            //cacheFlows = await this.storageService.getFlows(environment);
            this.flows$.next(newFlows);
            return newFlows;
        }
        else {
            this.flows$.next(newFlows);
            return newFlows;
        }
    }

    private async getFlowsLoopTeam(environment: string, getSolution = false) {

        let flowRequests: Flow[] = [];
        let requestUrl = '';
        let nextLink = '';
        let retry = true;
        let retryCount = 0;
        let storagePromises: Promise<string>[] = [];
        const top = 50;

        const optionApi = await firstValueFrom(this.optionApi$);

        while (retry) {

            this.serviceStatus$.next("Fetching Team Flows...");

            if (optionApi) {
                const api_root = this.getV2EnvironmentAPI(environment);
                const api_version = 1;
                const api_provider = 'powerautomate/'
                    requestUrl = `${api_root}${api_provider}flows?api-version=${api_version}${nextLink}` +
                `&$filter=search('team')` +
                `&$top=${top}` +
                `&$expand=properties.protectionStatus` +
                `&draftFlow=true` +
                ``;
            }
            else {
                requestUrl = `${this.API_ROOT}${this.PROVIDER}environments/${environment}/flows?api-version=${API_VERSION}${nextLink}` +
                `&$filter=search('team')` +
                (getSolution ? `&include=includeSolutionCloudFlows`: '') +
                `&$top=${top}` +
                `&$expand=properties.connectionreferences,properties.owners`;
            }
            // without searching for teams - some team flows don't show up!
            var pFlowsTeam: Flow[] = await this.sendRequest(requestUrl, {
                method: "GET"
            }).pipe(map((response: any) => {

                // let pOwners = []
                var flows = response.value.map((item: any) => {
                    return new Flow(item);
                });

                if (response.nextLink) {
                    nextLink = this.extractNextLink(response, nextLink);
                }
                else {
                    nextLink = '';
                    retry = false;
                }

                /*
                // if we find a flow that's earlier than prev, stop.
                if (flows.find((flow: Flow) => {
                    return flow.modified.toISOString() < prev;
                })) {
                    nextLink = '';
                }
                */
                return flows;
            })).pipe(catchError(err => {

                if (retryCount++ >= this.RETRY_LIMIT) {
                    this.serviceStatus$.next(`Error Fetching Team Flows: ${err.status}`);
                    throw err;
                }
                //nextLink = requestUrl;
                return of([]);
            })).toPromise();

            storagePromises.push(this.storageDexieService.putFlows(pFlowsTeam)!);
            flowRequests.push(...pFlowsTeam);

            if (!nextLink) {
                retry = false;
            }
        }

        await Promise.all(storagePromises);

        return flowRequests;
    }

    private async getFlowsLoopDataverse(environment: string) {

        // use dataverse token
        const token = this.msalHelperService.getCachedTokenInternal(['https://services.crm.dynamics.com/user_impersonation']);
        if (!token) {
            // can't continue
            return;
        }

        const ob = this.getSolutionFlows(environment).pipe(
            mergeMap((flows)=>{
                return flows
            }),
            // mergeMap((solution)=>{
            //     return this.getSolutionFlows(environment, solution.id)
            // }),
        );
        const flows = await ob.toPromise();
            
        return flows;
    }

    private extractNextLink(response: any, nextLink: string) {
        //let next = decodeURIComponent(response.nextLink);
        //var m = /(\$skiptoken=.*?)(\&|$)/gi.exec(next);
        let next = response.nextLink
        let m = /(%24skiptoken=.*?)(\&|$)/gi.exec(next);
        if (m) {
            //nextLink = '&' + m[1].replace('+', '%2B');
            nextLink = `&${m[1]}`;
        }
        return nextLink;
    }

    public async getFlowListPageForBrowserDataCacheProbe(environment: string, cursor: string | null = null): Promise<FlowListPageProbeResult> {
        const top = 50;
        const nextLink = cursor || '';
        const requestUrl = `${this.API_ROOT}${this.PROVIDER}environments/${environment}/flows?api-version=${API_VERSION}${nextLink}` +
            `&$filter=search('personal')` +
            `&$top=${top}`;
        const response = await this.sendRequest(requestUrl, { method: 'GET' }).toPromise();
        const nextCursor = response?.nextLink ? this.extractNextLink(response, nextLink) : null;
        return {
            items: response?.value || [],
            nextCursor,
            total: response?.value?.length,
        };
    }

    private async getFlowsLoop(environment: string, getSolution = false): Promise<Flow[]> {

        let flowRequests: Flow[] = [];
        let requestUrl = '';
        let nextLink = '';
        let retry = true;
        let retryCount = 0;
        let storagePromises: Promise<string>[] = [];
        let top = 50;

        const optionApi = await firstValueFrom(this.optionApi$);

        while (retry) {

            this.serviceStatus$.next("Fetching Flows...");

            if (optionApi) {
                const api_root = this.getV2EnvironmentAPI(environment);
                const api_version = 1;
                const api_provider = 'powerautomate/'
                requestUrl = `${api_root}${api_provider}flows?api-version=${api_version}${nextLink}` +
                    `&$filter=search('personal')` +
                    `&$top=${top}` +
                    `&$expand=properties.protectionStatus` +
                    `&draftFlow=true` +
                    ``;
            }
            else {
                requestUrl = `${this.API_ROOT}${this.PROVIDER}environments/${environment}/flows?api-version=${API_VERSION}${nextLink}` +
                //(filter ? filter :
                `&$filter=search('personal')` +
                //filter +
                `&$top=${top}` +
                (getSolution ? `&include=includeSolutionCloudFlows`: '') +
                ``;
                //`&$expand=properties.connectionreferences`;
            }
            // console.log(nextLink);

            var pFlowsPersonal: Flow[] = await this.sendRequest(requestUrl, {
                method: "GET"
            }).pipe(map((response: any) => {

                if (response.nextLink) {
                    nextLink = this.extractNextLink(response, nextLink)
                }
                else {
                    nextLink = '';
                    retry = false;
                }

                const flows = response.value.map((item: any) => new Flow(item));

                /*
                // if we find a flow that's earlier than prev, stop.
                if (flows.find((flow: Flow) => {
                    return flow.modified.toISOString() < prev;
                })) {
                    nextLink = '';
                }
                */
                return flows;
            })).pipe(catchError(err => {

                if (retryCount++ >= this.RETRY_LIMIT) {
                    this.serviceStatus$.next(`Error Fetching Personal Flows: ${err.status}`);
                    throw err;
                }
                //debugger;
                //nextLink = requestUrl;
                return of([]);
            })).toPromise();

            if (pFlowsPersonal) {
                storagePromises.push(this.storageDexieService.putFlows(pFlowsPersonal)!);

                flowRequests.push(...pFlowsPersonal);    
            }

            if (!nextLink) {
                retry = false;
            }
        }

        await Promise.all(storagePromises);

        return flowRequests;
    }

    private async getFlowsLoopAdmin(adminScope: string, environment: string): Promise<Flow[]> {

        let flowRequests: Flow[] = [];
        let requestUrl = '';
        let nextLink = '';
        let retry = true;
        let retryCount = 0;
        const top = 250;
        let storagePromises: Promise<string>[] = [];

        if (!this.token_flow_a) {
            return [];
        }

        while (retry) {

            this.serviceStatus$.next("Fetching Flows as Admin...");

            requestUrl = `${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${environment}/v2/flows?api-version=${API_VERSION}${nextLink}` +
                `&$top=${top}` +
                //filter +
                `&$expand=` +
                `properties.connectionreferences,` +
                `properties/users,` +
                `properties.creator,` +
                `swagger,` +
                `properties.api,` +
                `properties.connectionreferences.apidefinition,` +
                `properties.definitionSummary.operations.apiOperation,` +
                `properties.definition` +
                `&expandSuspensionInfo=true` +
                `&includeSoftDeletedFlows=true` +
                `&includeFlowDefinition=true`;

            var pFlowsAll: Flow[] = await this.sendRequest(requestUrl, {
                method: "GET"
            }).pipe(map((response: any) => {

                //nextLink = response.nextLink;
                if (response.nextLink) {
                    nextLink = this.extractNextLink(response, nextLink);
                }
                else {
                    nextLink = '';
                    retry = false;
                }

                var flows = response.value.map((item: any) => new Flow(item));

                /*
                // if we find a flow that's earlier than prev, stop.
                if (flows.find((flow: Flow) => {
                    return flow.modified.toISOString() < prev;
                })) {
                    //nextLink = null;
                }
                */
                return flows;
            })).pipe(catchError(res => {

                if (res.error && res.error.error && res.error.error.code == "EnvironmentAccessDenied") {
                    this.serviceStatus$.next(`Error Fetching Flows as Admin: ${res.status}`);
                    throw res;
                }

                if (retryCount++ >= this.RETRY_LIMIT) {

                    this.serviceStatus$.next(`Error Fetching Flows as Admin: ${res.status}`);
                    throw res;
                }

                //nextLink = requestUrl;
                return of([]);
            })).toPromise();

            if (pFlowsAll) {
                this.serviceStatus$.next(`Caching Flows as Admin (${pFlowsAll.length})...`);
                console.log(`[getFlowsLoopAdmin] received ${pFlowsAll.length} flows. sample[0]=`, pFlowsAll[0]);
                const putPromise = this.storageDexieService.putFlows(pFlowsAll, true)!;
                putPromise.then(
                    (res) => console.log(`[getFlowsLoopAdmin] putFlows(admin=true) resolved:`, res),
                    (err) => console.error(`[getFlowsLoopAdmin] putFlows(admin=true) REJECTED. message=${err?.message} name=${err?.name} code=${err?.code} stack=`, err?.stack, ' full:', err)
                );
                storagePromises.push(putPromise);
                flowRequests.push(...pFlowsAll);
            }

            if (!nextLink) {
                retry = false;
            }
        }

        await Promise.all(storagePromises);

        return flowRequests;
    }

    public async stasis(flows: Flow[], cacheFlows: Flow[], admin = false) {

        const newFlows = flows.filter((flow)=>{

            const cacheFlow = cacheFlows.find((f)=>f.flowName == flow.flowName);

            if(!cacheFlow) {
                return true;
            }
            if(
                flow.trigger != cacheFlow.trigger ||
                flow.triggerKind != cacheFlow.triggerKind ||
                flow.displayName != cacheFlow.displayName ||
                flow.flowState != cacheFlow.flowState) {
                  return true;
            }
            if(
                flow.modified > cacheFlow.modified
            ){
                return true;
            }
            if ((flow.triggerUrl || '') !== (cacheFlow.triggerUrl || '')) {
                return true;
            }
            if (JSON.stringify(flow.owners || []) !== JSON.stringify(cacheFlow.owners || [])) {
                return true;
            }
            return false;
        });

        this.serviceStatus$.next(`Saving ${newFlows.length} new Flows to cache.`);
        return this.storageDexieService.putFlows(newFlows, admin);
    }

    public hydrate(flows: Flow[], cacheFlows: Flow[]) {
        // take the same flow from cacheFlows and update it's properties
        flows.forEach((flow)=>{

          const cacheFlow = cacheFlows.find(f=>f.flowName == flow.flowName);
          if (!cacheFlow) {
            return;
          }
          if (!flow.triggerUrl && cacheFlow.triggerUrl) {
            flow.triggerUrl = cacheFlow.triggerUrl;
          }
          // Merge owners: live owners are authoritative for membership;
          // cached owners supply any display detail (name, email) not yet resolved live.
          if (cacheFlow.owners && cacheFlow.owners.length > 0) {
            const liveOwners: any[] = flow.owners || [];
            const cachedOwners: any[] = cacheFlow.owners || [];
            const getPrincipalId = (o: any): string =>
                o?.properties?.principal?.id || o?.properties?.principal?.objectId || '';
            if (liveOwners.length > 0) {
                flow.owners = liveOwners.map((liveOwner) => {
                    const id = getPrincipalId(liveOwner);
                    if (!id) return liveOwner;
                    const cached = cachedOwners.find((c) => getPrincipalId(c) === id);
                    if (!cached) return liveOwner;
                    const livePrincipal = liveOwner?.properties?.principal || {};
                    const cachedPrincipal = cached?.properties?.principal || {};
                    return {
                        ...cached,
                        ...liveOwner,
                        properties: {
                            ...cached.properties,
                            ...liveOwner.properties,
                            principal: { ...cachedPrincipal, ...livePrincipal }
                        }
                    };
                });
            } else {
                // No live owners returned — rehydrate entirely from cache.
                flow.owners = cachedOwners;
            }
          }
          if (flow.actionsCount == 0 && cacheFlow.actionsCount > 0) {
            flow.actionsCount = cacheFlow.actionsCount;
          }
          if (flow.triggers.length == 0 && cacheFlow.triggers.length > 0) {
            flow.triggers = cacheFlow.triggers;
          }
          if (!flow.actionsTooltip && cacheFlow.actionsTooltip) {
            flow.actionsTooltip = cacheFlow.actionsTooltip;
          }

        })
    }

    public async getApps(environment: string, admin: boolean): Promise<PowerApp[]> {
        // https://management.azure.com/providers/Microsoft.PowerApps/scopes/admin/environments/@{outputs('Compose_app-env-name')}/apps


        let retry = true;
        let requestUrl = '';
        let provider = 'providers/Microsoft.PowerApps/';
        let adminScope = admin ? 'scopes/admin/' : '';
        let version = '2016-11-01';
        let nextLink = '';
        let retryCount = 0;
        let appsAll: PowerApp[] = [];
        let requests: Promise<PowerApp[]>[] = [];

        while (retry) {


            if (admin) {
                this.serviceStatus$.next("Fetching PowerApps as Admin...");
                requestUrl = `${this.API_PA_ROOT}${provider}${adminScope}environments/${environment}/apps?$top=250&api-version=${version}${nextLink}`;
            }
            else {
                this.serviceStatus$.next("Fetching PowerApps...");
                requestUrl = `${this.API_PA_ROOT}${provider}apps?` +
                //`&api-version=${version}`+
                `${nextLink}` +
                `&$top=250`+
                //`$expand=permissions($filter=maxAssignedTo('36e3b856-3c2e-4605-ac5f-99064d229c3a'))&` +
                `&$filter=classification eq 'MyApps' and environment eq '${environment}'` +
                `&api-version=2017-06-01`
            }

            let pAppsBatch: Promise<PowerApp[]> = this.sendRequest(requestUrl, {
                method: "GET"
            }).pipe(map((response: any) => {

                //nextLink = response.nextLink;
                if (response.nextLink) {
                    nextLink = this.extractNextLink(response, nextLink);
                }
                else {
                    nextLink = '';
                    retry = false;
                }

                var apps = response.value.map((item: any) => new PowerApp(item));

                return apps;
            })).pipe(catchError(res => {

                if (res.error && res.error.error && res.error.error.code == "EnvironmentAccessDenied") {
                    this.serviceStatus$.next(`Error Fetching PowerApps: ${res.status}`);
                    throw res;
                }

                if (retryCount++ >= this.RETRY_LIMIT) {

                    this.serviceStatus$.next(`Error Fetching PowerApps: ${res.status}`);
                    throw res;
                }

                //nextLink = requestUrl;
                return of([]);
            })).toPromise();

            pAppsBatch.then(apps => {
                appsAll.push(...apps);
            })

            requests.push(pAppsBatch);

            if (!nextLink) {
                retry = false;
            }
        }

        return Promise.all(requests).then(()=>{

            this.serviceStatus$.next(``);
            return appsAll;
        });

    }

    public getApi(environment: string, apiName: string): Observable<any> {
        // https://api.powerapps.com/providers/Microsoft.PowerApps/apis?showApisWithToS=true&%24expand=permissions(%24filter%3DmaxAssignedTo(%2736e3b856-3c2e-4605-ac5f-99064d229c3a%27))&%24
        return this.sendRequest(`${this.API_PA_ROOT}${this.PA_PROVIDER}apis/${apiName}?$filter=environment eq '${environment}'&api-version=2017-06-01`, {
            method: "GET"
        });
    }

    public getFlow(environment: string, flowName: string, admin: boolean = false): Observable<any> {

        var adminScope = admin ? 'scopes/admin/' : '';
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${environment}/flows/${flowName}?api-version=${API_VERSION}&$expand=tags`, {
            method: "GET"
        });
    }

    public async getFlowsBatch(environment: string, flowNames: string[], admin: boolean = false): Promise<Map<string, any>> {
        const names = (flowNames || []).filter(Boolean);
        if (!names.length) {
            return new Map<string, any>();
        }
        if (!this.optionFlowBatchingApi$.getValue()) {
            throw new Error('Power Automate browser batch is disabled');
        }

        const adminScope = admin ? 'scopes/admin/' : '';
        const requests: PowerAutomateBatchRequest[] = names.map((flowName) => ({
            id: flowName,
            url: `${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${environment}/flows/${flowName}?api-version=${API_VERSION}&$expand=tags`,
        }));
        const token = await this.getPowerAutomateBatchToken(admin);
        if (!token?.secret) {
            throw new Error('Power Automate batch token is unavailable');
        }

        const workerResponses = await this.getFlowsBatchViaWorker(environment, names, admin, token.secret).catch((error) => {
            console.warn('[FlowManagementService] worker batch definition load failed; using main-thread batch', error);
            return null;
        });
        if (workerResponses) {
            return workerResponses;
        }

        const responses = await this.powerAutomateBatch.get(requests, { bearerToken: token.secret });
        const result = new Map<string, any>();
        const failures = responses.filter((response) => !response.ok);
        for (const response of responses) {
            if (response.ok) {
                result.set(response.id, response.body);
            } else if (admin && isPowerAutomateFlowNotFoundResponse(response)) {
                result.set(response.id, this.createDeletedFlowDetailMarker());
            }
        }
        if (failures.length) {
            console.warn('[FlowManagementService] Power Automate batch partial failures', failures.map((failure) => ({
                id: failure.id,
                status: failure.status,
                statusText: failure.statusText,
            })));
        }
        return result;
    }

    public async getFlowOwnersBatch(environment: string, flowNames: string[], admin: boolean = false): Promise<Map<string, any[]>> {
        const names = (flowNames || []).filter(Boolean);
        if (!environment || !names.length) {
            return new Map<string, any[]>();
        }
        if (!this.optionFlowBatchingApi$.getValue()) {
            throw new Error('Power Automate owner browser batch is disabled');
        }

        const token = await this.getPowerAutomateBatchToken(admin);
        if (!token?.secret) {
            throw new Error('Power Automate owner batch token is unavailable');
        }

        const workerResponses = await this.storageWorkerClient.loadFlowOwners({
            environment,
            flowNames: names,
            admin,
            bearerToken: token.secret,
            apiRoot: this.API_ROOT,
            provider: this.PROVIDER,
        }).catch((error) => {
            console.warn('[FlowManagementService] worker owner batch failed; using main-thread batch', error);
            return null;
        });
        if (workerResponses) {
            return this.toOwnerBatchMap(workerResponses);
        }

        const adminScope = admin ? 'scopes/admin/' : '';
        const requests: PowerAutomateBatchRequest[] = names.map((flowName) => ({
            id: flowName,
            url: `${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${environment}/flows/${flowName}/owners?api-version=${API_VERSION}&$expand=properties.principal.displayName`,
        }));
        const responses = await this.powerAutomateBatch.get(requests, { bearerToken: token.secret });
        return this.toOwnerBatchMap(responses.map((response) => ({
            id: response.id,
            ok: response.ok,
            status: response.status,
            statusText: response.statusText,
            owners: response.ok ? (response.body?.value || []) : undefined,
            deleted: admin && isPowerAutomateFlowNotFoundResponse(response),
            error: response.ok ? undefined : (response.body?.error?.message || response.bodyText || response.statusText),
        })));
    }

    public async getFlowRunsBatch(environment: string, flowNames: string[], admin: boolean = false, top = this.RUNS_API_TOP): Promise<Map<string, FlowRun[]>> {
        const names = (flowNames || []).filter(Boolean);
        if (!environment || !names.length) {
            return new Map<string, FlowRun[]>();
        }
        if (!this.optionFlowBatchingApi$.getValue()) {
            throw new Error('Power Automate runs browser batch is disabled');
        }

        const token = await this.getPowerAutomateBatchToken(admin);
        if (!token?.secret) {
            throw new Error('Power Automate runs batch token is unavailable');
        }

        const workerResponses = await this.storageWorkerClient.loadFlowRuns({
            environment,
            flowNames: names,
            admin,
            bearerToken: token.secret,
            apiRoot: this.API_ROOT,
            provider: this.PROVIDER,
            top,
        }).catch((error) => {
            console.warn('[FlowManagementService] worker runs batch failed; using main-thread batch', error);
            return null;
        });
        if (workerResponses) {
            return this.toRunsBatchMap(environment, workerResponses);
        }

        const adminScope = admin ? 'scopes/admin/' : '';
        const cappedTop = Math.max(1, Math.min(Number(top || this.RUNS_API_TOP), 50));
        const requests: PowerAutomateBatchRequest[] = names.map((flowName) => ({
            id: flowName,
            url: `${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${environment}/flows/${flowName}/runs?api-version=${API_VERSION}&$expand=properties/trigger&$top=${cappedTop}`,
        }));
        const responses = await this.powerAutomateBatch.get(requests, { bearerToken: token.secret });
        return this.toRunsBatchMap(environment, responses.map((response) => ({
            id: response.id,
            ok: response.ok,
            status: response.status,
            statusText: response.statusText,
            runs: response.ok ? (response.body?.value || []) : undefined,
            deleted: admin && isPowerAutomateFlowNotFoundResponse(response),
            error: response.ok ? undefined : (response.body?.error?.message || response.bodyText || response.statusText),
        })));
    }

    private async getFlowsBatchViaWorker(environment: string, flowNames: string[], admin: boolean, bearerToken: string): Promise<Map<string, any>> {
        const responses = await this.storageWorkerClient.loadSearchDefinitions({
            environment,
            flowNames,
            admin,
            bearerToken,
            apiRoot: this.API_ROOT,
            provider: this.PROVIDER,
        });
        const result = new Map<string, any>();
        const failures = (responses || []).filter((response) => !response.ok);
        for (const response of responses || []) {
            if (response.ok) {
                result.set(response.id, response.detail);
            } else if (admin && response.deleted) {
                result.set(response.id, this.createDeletedFlowDetailMarker());
            }
        }
        if (failures.length) {
            console.warn('[FlowManagementService] worker batch definition partial failures', failures.map((failure) => ({
                id: failure.id,
                status: failure.status,
                statusText: failure.statusText,
                error: failure.error,
            })));
        }
        return result;
    }

    private async getPowerAutomateBatchToken(admin: boolean): Promise<any> {
        const scopes = admin
            ? ['https://service.powerapps.com/User']
            : ['https://service.flow.microsoft.com//Flows.Manage.All'];
        return this.msalHelperService.getCachedTokenInternalAsync(scopes);
    }

    private toOwnerBatchMap(responses: Array<{ id: string; ok: boolean; owners?: any[]; status?: number; statusText?: string; deleted?: boolean; error?: string }>): Map<string, any[]> {
        const result = new Map<string, any[]>();
        const failures = (responses || []).filter((response) => !response.ok);
        for (const response of responses || []) {
            if (response.ok) {
                result.set(response.id, response.owners || []);
            } else if (response.deleted) {
                result.set(response.id, this.createDeletedFlowArrayMarker());
            }
        }
        if (failures.length) {
            console.warn('[FlowManagementService] Power Automate owner batch partial failures', failures.map((failure) => ({
                id: failure.id,
                status: failure.status,
                statusText: failure.statusText,
                error: failure.error,
            })));
        }
        return result;
    }

    private toRunsBatchMap(environment: string, responses: Array<{ id: string; ok: boolean; runs?: any[]; status?: number; statusText?: string; deleted?: boolean; error?: string }>): Map<string, FlowRun[]> {
        const result = new Map<string, FlowRun[]>();
        const failures = (responses || []).filter((response) => !response.ok);
        for (const response of responses || []) {
            if (!response.ok) {
                if (response.deleted) {
                    result.set(response.id, this.createDeletedFlowArrayMarker() as FlowRun[]);
                }
                continue;
            }
            const flowName = response.id;
            const runs = (response.runs || []).map((run: any) => {
                const mapped = new FlowRun(run);
                mapped.flowName = mapped.flowName || flowName;
                mapped.environment = mapped.environment || environment;
                return mapped;
            });
            result.set(flowName, runs);
        }
        if (failures.length) {
            console.warn('[FlowManagementService] Power Automate runs batch partial failures', failures.map((failure) => ({
                id: failure.id,
                status: failure.status,
                statusText: failure.statusText,
                error: failure.error,
            })));
        }
        (result as any).__failures = failures;
        return result;
    }

    public isDeletedFlowDetailMarker(item: any): boolean {
        return !!item?.[FLOW_STUDIO_DELETED_DETAIL_MARKER];
    }

    private createDeletedFlowDetailMarker(): any {
        return { [FLOW_STUDIO_DELETED_DETAIL_MARKER]: true };
    }

    private createDeletedFlowArrayMarker<T = any>(): T[] {
        const marker: T[] = [];
        (marker as any)[FLOW_STUDIO_DELETED_DETAIL_MARKER] = true;
        return marker;
    }

    private isDeletedFlowArrayMarker(items: any[] | null | undefined): boolean {
        return !!(items as any)?.[FLOW_STUDIO_DELETED_DETAIL_MARKER];
    }

    private markFlowDeleted(flow: Flow): void {
        flow.flowState = 'Deleted';
        flow.loading = false;
        flow.nextLink = '';
    }

    private async markAdminFlowsDeleted(environment: string, flowNames: string[], flows?: Flow[]): Promise<void> {
        const names = new Set((flowNames || []).filter(Boolean));
        if (!environment || names.size === 0) return;
        const candidates = flows?.length
            ? flows
            : await this.storageDexieService.getFlowsAdmin().catch(() => [] as Flow[]);
        const deleted = (candidates || []).filter((flow) => flow?.environment === environment && names.has(flow.flowName));
        if (!deleted.length) return;
        deleted.forEach((flow) => this.markFlowDeleted(flow));
        await this.storageDexieService.putFlows(deleted, true);
    }

    public runFlow(environment: string, flowName: string, triggers: any[]) : Observable<any> {

        const [trigger] = triggers;
        let triggerName = null;
        if (trigger.type == 'Request' && trigger.kind == 'Button') {
            triggerName = 'manual';
        }
        if (!triggerName) {
            return of(null);
        }
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/flows/${flowName}/triggers/${triggerName}/run?api-version=${API_VERSION}&$expand=tags`, {
            method: "POST",
            body: {
            }
        });
    }

    public async getApp(environment: string, name: string, admin: boolean = false): Promise<any> {
        let provider = 'providers/Microsoft.PowerApps/';
        let adminScope = admin ? 'scopes/admin/' : '';
        let version = '2017-06-01';

        version = '2017-08-01';

        let pApp = this.sendRequest(`${this.API_ROOT}${provider}${adminScope}apps/${name}?api-version=${version}&$expand=tags,properties.connectionreferences`, {
            method: "GET"
        }).toPromise();

        return pApp.then(app=>{

            let ownerId = app.properties.owner.id;
            let version = '2017-06-01'


            let pConnections = (async()=>{
                let connections = [];

                let url = `${this.API_ROOT}${provider}${adminScope}apps/${name}/connections`+
                `?api-version=${version}`+
                `&$expand=permissions($filter=maxAssignedTo('${ownerId}'))`+
                `&$filter=environment eq '${environment}'`+
                `&$top=250`+
                ``;

                while(true) {
                    let response = await this.sendRequest(
                        url,{
                        method: "GET"
                    }).toPromise();

                    connections.push(...(response.value||[]));

                    url = response.nextLink;
                    if (!url) {
                        break;
                    }
                }

                return connections;
            })();

            return pConnections.then(connections=>{

                Object.keys(app.properties.connectionReferences).map(key=>{

                    let connection = connections.find(c=>c.properties.reference == key);
                    if (connection) {
                        app.properties.connectionReferences[key].connection = connection;
                        app.properties.connectionReferences[key].connectionName = connection.name;
                    }
                })

                //debugger;

                return app;
            })
        })
        // providers/Microsoft.PowerApps/apps/b0054a33-f9a1-46d3-a7a9-0a6da6322deb/connections?
        // $expand=permissions($filter=maxAssignedTo('36e3b856-3c2e-4605-ac5f-99064d229c3a'))
        // &api-version=2017-06-01
        // &%24skiptoken=eyJmYWlsdXJlRm91bmQiOmZhbHNlLCJsYXN0UmVnaXN0cmF0aW9uU2VlbiI6InNoYXJlZCIsImxhc3RDb250aW51YXRpb25Ub2tlblNlZW4iOiJleUpRU3lJNklqRWhPQ0ZTVlU1SFRtdEZMU0lzSWxKTElqb2lNU0V5TWpRaFRXcGFSazVxVlhsTmFrRTJUV3RSTVU1VVdYaFBha3BGVGtSYVJsSnFiM2xTUkdzelQwUk5OazFyVWtSU1ZGWkhUV3BCTUU5RWEzbE9SRVptVlVWR1JGUnBNSHBPYTFWNlVXcG5NVTVxYjNsU1JFNUVUV3RWTmsxclVUQk9ha0V4VDJwS1JWRlZUVEZTYW05NVVrUnJOVTFFV1RCU1JFbDVUMVZOZWxGVE1VSldWazVWVld0R1RWTlZSVFpOYTFGM1RVUkZkRlJGT1VoVFZVNUhWRVU1V0ZWNU1VWlNWRTE1VVhwcmVrOVViM2xTUkdzeFVUQk5OazFyVVRCU1ZWSkNUMnBLUlU5RVFrTlNWRzk1VWtSWmVWRjZSa0pPZWtVeFRYcEZOVTVuTFMwaUxDSlBTVVFpT2lJek5tVXpZamcxTmkwell6SmxMVFEyTURVdFlXTTFaaTA1T1RBMk5HUXlNamxqTTJFaWZRPT0ifQ%3d%3d


    }

    public putApp(app: any, admin = false) {

        // /providers/Microsoft.PowerApps/objectIds/36e3b856-3c2e-4605-ac5f-99064d229c3a/generateResourceStorage?api-version=2018-10-01
        // {"environment":{"id":"/providers/Microsoft.PowerApps/environments/Default-26e65220-5561-46ef-9783-ce5f20489241","name":"Default-26e65220-5561-46ef-9783-ce5f20489241"}}

        ///providers/Microsoft.PowerApps/apps/b0054a33-f9a1-46d3-a7a9-0a6da6322deb?api-version=2018-10-01
        //{"properties":{"appUris":{"documentUri":{"value":"https://pafeblobprodml.blob.core.windows.net/20190925t000000zb1d676bfcc7b43e3ba061e8e4d5fee27/document.msapp?sv=2018-03-28&sr=c&si=SASpolicy&sig=49HXs83wOdRTMk4NNcol90jTAVYggXomzzF09AUQUic%3D"}},"displayName":"a-powerapp","backgroundImageUri":"https://pafeblobprodml.blob.core.windows.net/20190925t000000zb1d676bfcc7b43e3ba061e8e4d5fee27/logoSmallFile?sv=2018-03-28&sr=c&si=SASpolicy&sig=49HXs83wOdRTMk4NNcol90jTAVYggXomzzF09AUQUic%3D","description":"","commitMessage":"","environment":{"id":"/providers/Microsoft.PowerApps/environments/Default-26e65220-5561-46ef-9783-ce5f20489241","name":"Default-26e65220-5561-46ef-9783-ce5f20489241"},"backgroundColor":"rgba(0, 176, 240, 1)","minClientVersion":{"major":3,"minor":19092,"build":12,"majorRevision":0,"minorRevision":0,"revision":0},"createdByClientVersion":{"major":3,"minor":19092,"build":12,"majorRevision":0,"minorRevision":0,"revision":0},"lifeCycleId":"Draft","connectionReferences":{"fb35f7ca-a96f-460d-ab37-128680e307c4":{"id":"/providers/microsoft.powerapps/apis/shared_sharepointonline","parameterHints":{},"dataSources":["a-powerapps-list"],"datasets":{"https://johnliu365.sharepoint.com":{"dataSources":{"a-powerapps-list":{"tableName":"0f53a501-8291-442a-82d7-aab59fb835a7"}}}},"dependents":[],"dependencies":[],"isOnPremiseConnection":false}}},"tags":{"sp-site-id":"https://johnliu365.sharepoint.com","sp-list-id":"0f53a501-8291-442a-82d7-aab59fb835a7","https://johnliu365.sharepoint.com":"0f53a501-8291-442a-82d7-aab59fb835a7","primaryDeviceWidth":"640","primaryDeviceHeight":"1136","sienaVersion":"0b9abe58-1d33-4023-b139-b5ff3b82499d","deviceCapabilities":"","supportsPortrait":"true","supportsLandscape":"false","primaryFormFactor":"Phone","publisherVersion":"3.19092.12","minimumRequiredApiVersion":"2.2.0","hasComponent":"false","hasNonOOBComponent":"false"}}

        // sharedAccessSignature: "https://pafeblobprodml.blob.core.windows.net/20190927t000000ze2c21b588bd64af2bca508a18dcabb60?sv=2018-03-28&sr=c&si=SASpolicy&sig=R3lmS3lk5v58GVu34NKlOGBMts%2FQnnBBGbrFx0vijkA%3D"
        // "https://pafeblobprodml.blob.core.windows.net/20190927t000000ze2c21b588bd64af2bca508a18dcabb60/document.msapp?sv=2018-03-28&sr=c&si=SASpolicy&sig=R3lmS3lk5v58GVu34NKlOGBMts%2FQnnBBGbrFx0vijkA%3D"
        let provider = 'providers/Microsoft.PowerApps/';
        let adminScope = admin ? 'scopes/admin/' : '';
        // let version = '2017-06-01';
        let version = '2017-08-01';
        //let version = '2018-10-01';
        // apps/b0054a33-f9a1-46d3-a7a9-0a6da6322deb?api-version=2018-10-01
        let owner = app.properties.owner.id; // '36e3b856-3c2e-4605-ac5f-99064d229c3a';
        let environment = app.properties.environment.name; // 'Default-26e65220-5561-46ef-9783-ce5f20489241';

        // /providers/Microsoft.PowerApps/apps/18c89e9c-9305-46de-94c3-07bc235ec26f/acquireLease?api-version=2018-10-01
        let pLease = this.sendRequest(`${this.API_ROOT}${provider}apps/${app.name}/acquireLease?api-version=${version}`, {
            method: "POST",
            body: null
        }).toPromise();
        // expiry: "2019-09-27T13:58:12Z"
        // leaseId: "6020de4d-8225-4a30-af9a-5cd4d26fb844"
        // lessee: {id: "36e3b856-3c2e-4605-ac5f-99064d229c3a", displayName: "John Liu",…}
        // displayName: "John Liu"
        // email: "john.liu@johnliu365.onmicrosoft.com"
        // id: "36e3b856-3c2e-4605-ac5f-99064d229c3a"
        // tenantId: "26e65220-5561-46ef-9783-ce5f20489241"
        // type: "User"
        // userPrincipalName: "john.liu@johnliu365.onmicrosoft.com"

        return pLease.then(lease=>{
/*
            let pStore = this.sendRequest(`${this.API_ROOT}${provider}objectIds/${owner}/generateResourceStorage?api-version=${version}`, {
                method: "POST",
                body: {
                    "environment":{
                        "id":`/providers/Microsoft.PowerApps/environments/${environment}`,
                        "name":`${environment}`
                    }
                }
            }).toPromise();

            return pStore;
        }).then(value=>{
            return value.sharedAccessSignature;
        }).then(sig => {

*/
            Object.keys(app.properties.connectionReferences).forEach(key=>{

                let cref = app.properties.connectionReferences[key];

                delete cref.connection
                delete cref.connectionName

                cref.datasets = cref.dataSets;
                delete cref.dataSets;

            });

            // let parts = sig.split('?')

            //app.properties.appUris.documentUri.value = `${parts[0]}/document.msapp?${parts[1]}`;
            // delete app.properties.appUris.documentUri.readonlyValue;

            //app.properties.backgroundImageUri = `${parts[0]}/logoSmallFile?${parts[1]}`;
            app.properties.lifeCycleId = 'Draft';
            app.properties.commitMessage = 'Saved by FlowStudio';
            // delete app.properties.appPackageDetails;
            // delete app.properties.appVersion;
            // delete app.properties.lastDraftVersion;
            // delete app.properties.status;
            // delete app.properties.userAppMetadata;

            // app.tags.sienaVersion = `${uuidv4()}`;


            return app;
        }).then(app=> {

            let pApp = this.sendRequest(`${this.API_ROOT}${provider}${adminScope}apps/${app.name}?api-version=${version}`, {
                method: "PUT",
                body: app
            }).toPromise();

            return pApp;
        })


        // /providers/microsoft.powerapps/apis/shared_sharepointonline/connections/7074430539ef4097bb0646eae5601ca5/usages?api-version=2018-10-01&%2524filter=environment+eq+%2527Default-26e65220-5561-46ef-9783-ce5f20489241%2527
        // reference: "fb35f7ca-a96f-460d-ab37-128680e307c4"
        // resourceId: "/providers/Microsoft.PowerApps/apps/b0054a33-f9a1-46d3-a7a9-0a6da6322deb"


        // return pApp;
    }

    public getFlowOwners(flow: Flow, admin: boolean = false, skipSave = true) {
        return from(this.getFlowOwnersBatch(flow.environment, [flow.flowName], admin).then((ownersByFlow) => {
            const owners = ownersByFlow.get(flow.flowName) || [];
            if (admin && this.isDeletedFlowArrayMarker(owners)) {
                this.markFlowDeleted(flow);
                if (!skipSave) {
                    this.storageDexieService.putFlow(flow, true);
                }
                return [];
            }
            flow.owners = owners;
            if (!skipSave) {
                this.storageDexieService.putFlow(flow, admin);
            }
            return owners;
        }).catch((error) => {
            console.warn('[FlowManagementService] owner batch failed; falling back to direct owner request', error);
            return firstValueFrom(this.getFlowOwnersDirect(flow, admin, skipSave));
        }));
    }

    private getFlowOwnersDirect(flow: Flow, admin: boolean = false, skipSave = true) {

        var adminScope = admin ? 'scopes/admin/' : '';

        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${flow.environment}/flows/${flow.flowName}/owners?api-version=${API_VERSION}&$expand=properties.principal.displayName`, {
            method: "GET"
        }).pipe(map(res => {

            const owners = res.value;
            flow.owners = owners;
            if (!skipSave) {
                this.storageDexieService.putFlow(flow, admin);
            }
            return owners;
        }), catchError((error) => {
            const status = Number(error?.status || error?.error?.status || 0);
            const code = String(error?.error?.error?.code || error?.error?.code || '');
            if (admin && status === 404 && code === 'FlowNotFound') {
                this.markFlowDeleted(flow);
                if (!skipSave) {
                    this.storageDexieService.putFlow(flow, true);
                }
                return of([]);
            }
            return throwError(error);
        }));
    }

    public getFlowOwnersAsAdmin(flow: Flow) {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}scopes/admin/environments/${flow.environment}/flows/${flow.flowName}/owners?api-version=${API_VERSION}`, {
            method: "GET"
        }).pipe(map(res => res.value));
    }

    public putFlowOwnerAsAdmin(flow:Flow, oid: string) {

        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}scopes/admin/environments/${flow.environment}/flows/${flow.flowName}/modifyOwners?api-version=${API_VERSION}`, {
            method: "POST",
            body: {
                "put":[
                    {
                        "properties":{
                            "principal":{
                                "id":oid,
                                "type":"User"
                            }
                        }
                    }
                ]
            }
        });

    }

    public modifyOwnersAsAdmin(flow: Flow, permissions: any[]) {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}scopes/admin/environments/${flow.environment}/flows/${flow.flowName}/modifyOwners?api-version=${API_VERSION}`, {
            method: "POST",
            body: permissions
        });
    }

    public restoreFlowAsAdmin(flow: Flow) {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}scopes/admin/environments/${flow.environment}/flows/${flow.flowName}/restore?api-version=${API_VERSION}`, {
            method: "POST",
        });
    }

    public getCurrentUser(): AccountInfo {
        return this.msalHelperService.getUser();
    }

    public getSubscription(get = false): Observable<any> {
        var userId = this.getCurrentUser().username;

        var url = `/api/subscription`;

        if (get == true) {
            return this.httpClient.post(url, {
                "logon": userId,
                "token": {
                    "livemode": true
                },
                "timestamp": (new Date()).toISOString()
            }, {
                headers: {
                    "X-HTTP-Method": "get"
                }
            });
        }
        return this.httpClient.post(url, {
            "logon": userId,
            "timestamp": (new Date()).toISOString()
        });
    }

    public async updateSubscription(token: string, product: string, coupon = null): Promise<any> {
        const { 
            username: userId,
            tenantId,
            idToken
        } = this.getCurrentUser();

        var url = `/api/subscription`;

        const p = this.httpClient.post(url, {
            "logon": userId,
            "token": token,
            "product": product,
            "coupon": coupon,
            "tenant": tenantId,
            "timestamp": (new Date()).toISOString()
        }, {
            headers: {
                "X-HTTP-Method": "merge",
                "X-Authorization": idToken ?? ''
            }
        }).toPromise();
        
        // p.then(()=>{
        //     refreshQuery(`subscription-get-${userId}`);
        // });
        return p;
    }

    public async updateUsers(workspace: string, users: any[], join = false): Promise<any> {
        const { 
            username: userId,
            tenantId
        } = this.getCurrentUser();

        var url = `https://${window.location.hostname}/users`;
        if (window.location.hostname == "localhost") {
            url = `https://dev.flowstudio.app/users`
        }

        const p = this.httpClient.post(url, {
            "admin": userId,
            workspace,
            "tenant": tenantId,
            users,
            join
        }/*,{
            headers: {
                "X-HTTP-Method": "merge"
            }
        }*/).toPromise();
        
        // p.then(()=>{
        //     refreshQuery(`subscription-get-${userId}`);
        // });
        return p;
    }

    public resolveUser(tenant: string = "26e65220-5561-46ef-9783-ce5f20489241", users: string) {
        return this.sendRequest(`https://graph.windows.net/${tenant}/getObjectsByObjectIds?api-version=1.6`, {
            method: "POST",
            body: {
                "objectIds": ["b2e3adeb-1359-4a83-9f28-c772ad033f34"], "types": ["group", "user"]
            }
        }).pipe(map(res => res.value));


    }

    public getUserAsAdmin(userId: string, environment: string) {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}scopes/admin/users/${userId}?api-version=${API_VERSION}`, {
            method: "GET"
        }).pipe(map(res => res.value));
    }

    public deleteFlowOwnerAsAdmin(flow: Flow, owner: string) {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}scopes/admin/environments/${flow.environment}/flows/${flow.flowName}/owners/${owner}?api-version=${API_VERSION}`, {
            method: "DELETE"
        });
    }

    public createFlow(environment: string, flowData: any): Observable<any> {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/flows?api-version=${API_VERSION}`, {
            method: "POST",
            body: flowData
        });
    }

    public validateFlow(environment: string, flowName: string, flow: any): Observable<any> {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/flows/${flowName}/validate?api-version=${API_VERSION}`, {
            method: "POST",
            body: flow
        });
    }

    public updateFlow(environment: string, flowName: string, flow: any): Observable<any> {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/flows/${flowName}?api-version=${API_VERSION}` +
            `&$expand=swagger,properties.connectionreferences.apidefinition,properties.definitionSummary.operations.apiOperation`, {
                method: "PATCH",
                body: flow
            });
    }

    public updateFlowDescription(flow: Flow) {
        return this.getFlow(flow.environment, flow.flowName).toPromise().then((flowData) => {

            var description = flowData.properties.definitionSummary['description'] || '';

            flowData.properties.definition['description'] = flow.description;
            flowData.properties.definitionSummary['description'] = flow.description;

            return this.
                updateFlow(flow.environment, flow.flowName, flowData).toPromise();
        });
    }

    public stopFlow(environment: string, flowName: string, admin: boolean = false) {
        var adminScope = admin ? 'scopes/admin/' : '';
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${environment}/flows/${flowName}/stop?api-version=${API_VERSION}`, {
            method: "POST"
        })
    }

    public startFlow(environment: string, flowName: string, admin: boolean = false) {
        var adminScope = admin ? 'scopes/admin/' : '';
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${environment}/flows/${flowName}/start?api-version=${API_VERSION}`, {
            method: "POST"
        })
    }

    public deleteFlow(flow: Flow, admin: boolean = false) {
        var adminScope = admin ? 'scopes/admin/' : '';
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${flow.environment}/flows/${flow.flowName}?api-version=${API_VERSION}`, {
            method: "DELETE"
        }).pipe(map((value)=>{
            flow.flowState = 'Deleted'
            this.storageDexieService.putFlow(flow);

            //this.storageService.updateFlow(flow)
            return value;
        }))
    }

    public getFlowTriggers(flow: Flow, admin: boolean = false): Promise<any> {

        // https://australia.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-eadd1a95-7e83-457f-8177-6aed1fa73f2a/flows/ced8b72f-7ebe-4cef-b5af-33517386ed5a
        // /triggers/When_an_item_is_created_or_modified/histories?api-version=2016-11-01&id=@id&$expand=properties%2Frun%2Fproperties&$top=40&$filter=Status%20eq%20%27failed%27

        // debugger

        var adminScope = admin ? 'scopes/admin/' : '';

        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${flow.environment}/flows/${flow.flowName}/triggers?api-version=${API_VERSION}`, {
            method: "GET"
        }).pipe(catchError(err => [])).toPromise();
    }

    public getFlowTriggerHistory(flow: Flow, triggerName: string, status: string = 'failed'): Promise<any> {

        // https://australia.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-eadd1a95-7e83-457f-8177-6aed1fa73f2a/flows/ced8b72f-7ebe-4cef-b5af-33517386ed5a
        // /triggers/When_an_item_is_created_or_modified/histories?api-version=2016-11-01&id=@id&$expand=properties%2Frun%2Fproperties&$top=40&$filter=Status%20eq%20%27failed%27


        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${flow.environment}/flows/${flow.flowName}/triggers/${triggerName}/histories?api-version=${API_VERSION}&id=@id&$expand=properties/run/properties&$top=40&$filter=Status eq 'failed'`, {
            method: "GET"
        }).toPromise();
    }

    public getFlowRunTrigger(run: FlowRun, keepHeaders = false): Promise<any> {

        var triggerInputUri = null, triggerOutputUri = null;
        var triggerInputSize = 0, triggerOutputSize = 0;
        if (!run.raw.properties.trigger) {
            // from history
            triggerInputUri = run.raw.properties.inputsLink.uri;
            triggerInputSize = run.raw.properties.inputsLink.contentSize;
        }
        else {
            if (run.raw.properties.trigger.inputsLink) {
                triggerInputUri = run.raw.properties.trigger.inputsLink.uri;
                triggerInputSize = run.raw.properties.trigger.inputsLink.contentSize;
            }
            if (run.raw.properties.trigger.name == 'manual') {
                triggerInputUri = '';
                triggerInputSize = 0;
            }

            if (run.raw.properties.trigger.outputsLink) {
                triggerOutputUri = run.raw.properties.trigger.outputsLink.uri;
                triggerOutputSize = run.raw.properties.trigger.outputsLink.contentSize;
            }
        }

        var promises = []

        if (triggerInputUri && triggerInputSize < 1000000) {
            var p0 = this.sendRequest(`${triggerInputUri}`, {
                method: "GET"
            }).toPromise();
            promises.push(p0);
        }
        if (triggerOutputUri && triggerOutputSize < 1000000) {
            var p1 = this.sendRequest(`${triggerOutputUri}`, {
                method: "GET"
            }).toPromise();
            promises.push(p1);
        }
        else if (run.raw.properties.error) {

            promises.push(Promise.resolve(run.raw.properties.error));
        }

        if (promises.length == 0) {
            if (triggerInputSize >= 1000000 || triggerOutputSize >= 1000000) {
                return Promise.resolve(`This trigger has very large (${triggerInputSize || triggerOutputSize} bytes) trigger data (probably file binary), skipped.`);
            }
            return Promise.resolve('This connector does not have trigger input/output data.');
        }

        const filters = keepHeaders ? ['authentication', 'host'] : ['headers', 'authentication', 'host'];

        return Promise.all(promises).then((responses) => {
            return responses.map(r => {
                filters.forEach((key) => {
                    if (r[key]) {
                        delete r[key];
                        //r[key]='...';
                    }
                })
                return r;
            });
        });
    }

    public getFlowTriggerUrl(environment: string, flowName: string, showDeprecatedCallbackUrl=false): Promise<string> {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/flows/${flowName}/triggers/manual/listCallbackUrl?api-version=${API_VERSION}${showDeprecatedCallbackUrl?'&showDeprecatedCallbackUrl=true':''}`, {
            method: "POST"
        }).pipe(map(res => res.response ? res.response.value : null)).toPromise();
    }

    public getFlowRuns$(environmentName: string, flowName: string, admin: boolean = false): Observable<FlowRun[]> {
        let flow : Flow = Object.assign(new Flow(), { environment: environmentName, flowName: flowName });
        return from(this.getFlowRuns(flow, false, false, admin, 0, false));
    }

    public async getFlowRuns(flow: Flow, deep: boolean = false, loadTriggers: boolean = false, admin: boolean = false, more: number = 0, silent = false): Promise<FlowRun[]> {
        // 403 retry: when a user-scope read is denied (typically
        // `ConnectionAuthorizationFailed` because the caller doesn't own the
        // flow's connection), retry once through the admin scope. Skipped
        // when admin is already true.
        if (!admin) {
            try {
                return await this.getFlowRunsInner(flow, deep, loadTriggers, false, more, silent);
            } catch (err: any) {
                const status = Number(err?.status || err?.error?.status || 0);
                const code = err?.error?.error?.code || '';
                const looksLikeAuthFailure = status === 403 ||
                    status === 401 ||
                    code === 'ConnectionAuthorizationFailed' ||
                    code === 'AuthorizationFailed';
                if (!looksLikeAuthFailure) throw err;
                console.warn(`[runs] ${flow?.flowName} returned ${status} ${code}; retrying with admin scope`);
                return await this.getFlowRunsInner(flow, deep, loadTriggers, true, more, silent);
            }
        }
        return await this.getFlowRunsInner(flow, deep, loadTriggers, true, more, silent);
    }

    /** Original implementation — see `getFlowRuns` for the public wrapper that
     *  adds 403-retry-with-admin on top. */
    private async getFlowRunsInner(flow: Flow, deep: boolean, loadTriggers: boolean, admin: boolean, more: number, silent: boolean): Promise<FlowRun[]> {
        let runs: FlowRun[] = [];
        let all: FlowRun[] = [];
        var retry = true;
        var nextLink = '';
        var filter = '';
        var prev: string | null = null;

        //let flow:Flow = clone ? {..._flow} : _flow;

        //var x_cacheRuns: FlowRun[] = flow.runs;

        // if (cacheRuns && cacheRuns.length) {

        //     cacheRuns = cacheRuns.filter(run=>!!run.startTime);

        //     if (!deep) {
        //         prev = cacheRuns[0].startTime.toISOString();
        //         filter = `&$filter=startTime gt ${prev} `
        //     }

        //     //runs.push(...cacheRuns);
        // }
        // if (flow.checkRuns == -1) {
        //     if (deep || loadTriggers || more) {
        //         // continue
        //     }
        //     else {
        //         return [];
        //     }
        // }

        if (flow.flowState == "Deleted") {
            return [];
        }
        if (more && flow.more) {
            nextLink = flow.nextLink;
        }

        var adminScope = admin ? 'scopes/admin/' : '';
        var adminV2 = admin ? '/v2' : '';
        const adminText = admin ? ' (as Admin)' : '';

        flow.loading = true;

        while (retry) {

            if (!silent) {
                this.serviceStatus$.next(`Fetching Flow runs${adminText}`);
            }

            var batch: FlowRun[] = await this.sendRequest(`${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${flow.environment}/flows/${flow.flowName}/runs?api-version=${API_VERSION}&$expand=properties/trigger${filter}${nextLink}`, {
                method: "GET"
            }).pipe(
                catchError(res=>{
                    if (admin && res.error && res.error.error && res.error.error.code == "FlowNotFound") {
                        this.markFlowDeleted(flow);
                        this.storageDexieService.putFlow(flow, true);
                        return [];
                    }
                    return throwError(res);
                }),                 
                map((response: any) => {

                if (deep) {
                    retry = true;
                }
                if (more > 0) {
                    retry = true;
                    more--;
                }

                if (response.nextLink) {
                    // nextLink = decodeURIComponent(response.nextLink);
                    // var m = /(\$skiptoken=.*?)(\&|$)/gi.exec(nextLink);
                    let next = response.nextLink
                    let m = /(%24skiptoken=.*?)(\&|$)/gi.exec(next);
                    if (m) {
                        //nextLink = '&' + m[1].replace('+', '%2B');
                        nextLink = `&${m[1]}`;
                        flow.nextLink = nextLink;
                    }
                }
                else {
                    // out of pages
                    retry = false;
                    // "providers/Microsoft.ProcessSimple/environments/Default-26e65220-5561-46ef-9783-ce5f20489241/flows/9e00ea27-9f05-4e3b-a86e-3f12ae9d9235/runs?api-version=2016-11-01&%24skiptoken=eyJuZXh0UGFydGl0aW9uS2V5IjoiMSE4IVJqUTBPVFUtIiwibmV4dFJvd0tleSI6IjEhODQhTWtJeFFVTTJRemN3T1RjME5ESTJRVGxDUmpaRE9FUTRNRUZGTlVRMU16TmZNRGcxT0RZM05EWTRNVFF5TlRReU5USTROakl3TWpRME16RXlPVEEtIn0%3d"
                }

                if (more == 0 && !deep) {
                    // more - reads next page so it's finished, unless we are on deep
                    retry = false;
                }

                let runs = response.value.map((item: any) => {
                    var run = new FlowRun(item);
                    run.flowName = flow.flowName;
                    run.environment = flow.environment;
                    return run;
                });

                flow.setNextScan(runs.length);

                if (prev) {
                    runs = runs.filter((item: FlowRun) => item.startTime && item.startTime.toISOString() > prev || item.endTime && item.endTime.toISOString() > prev);
                }
                return runs;
            })).pipe(catchError(err => {
                if (!silent) {
                    this.serviceStatus$.next(`Error Fetching Flow Runs: ${err.status}`);
                }
                throw err;
            })).toPromise();

            if (!batch || !batch.length) {
                break;
            }

            /*
            batch.forEach((value: FlowRun) => {
                var index = cacheRuns.findIndex(value1 => value1.name == value.name);
                if (index != -1) {
                    cacheRuns[index] = value;
                }
            });

            batch = batch.filter((value: FlowRun) => {
                return cacheRuns.findIndex(value1 => value1.name == value.name) == -1;
            });
            */

            if (batch.length) {
                runs.push(...batch);
            }

            // limitation set in indexdb
            // if (runs.length > 2000) {
            //     break;
            // }

            // if (retry && runs.length >= 50 ) {
            //     retry = false;
            // }
        }

        if (loadTriggers && !admin) {
            // load history


            // https://australia.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-eadd1a95-7e83-457f-8177-6aed1fa73f2a/flows/ced8b72f-7ebe-4cef-b5af-33517386ed5a
            // /triggers/When_an_item_is_created_or_modified/histories?api-version=2016-11-01&id=@id&$expand=properties%2Frun%2Fproperties&$top=40&$filter=Status%20eq%20%27failed%27

            //var triggers =
            await this.getFlowTriggers(flow, admin).then(triggers => {

                if (!triggers || !triggers.value || !triggers.value.length) {
                    return;
                }

                //if (triggers && triggers.value && triggers.value.length && triggers.value[0].name) {
                return this.getFlowTriggerHistory(flow, triggers.value[0].name).then(histories => {

                    if (histories && histories.value.length) {
                        var failedTriggers = histories.value.map((item: any) => {
                            var run = new FlowRun(item);
                            run.flowName = flow.flowName;
                            run.environment = flow.environment;
                            run.triggerName = triggers.value[0].name;
                            run.status += " (trigger)";
                            return run;
                        });

                        /*
                        failedTriggers = failedTriggers.filter((value: FlowRun) => {
                            return cacheRuns.findIndex(value1 => value1.name == value.name) == -1;
                        });
                        */

                        if (failedTriggers.length) {
                            runs.push(...failedTriggers);
                        }
                    }
                    return failedTriggers;
                });
                //}
            });

        }

        if (runs && runs.length) {
            /*
            flow.runs should be managed by storage
            
            flow.runs.push(...runs);
            flow.runs.sort((a, b) => (b.startTime ? b.startTime.getTime() : 0) - (a.startTime ? a.startTime.getTime() : 0));
            */

            // flow.runs.reduce((cur, next:FlowRun)=>{
            //     return cur.then(()=>{
            //         if (next.triggerData) {
            //             return Promise.resolve();
            //         }
            //         else {
            //             var p = this.getFlowRunTrigger(next);
            //             p.then((triggerOutput)=>{
            //                 next.triggerData = triggerOutput;
            //             });
            //             return p;
            //         }
            //     });
            // }, Promise.resolve()).then(()=>{
            //     //all executed
            // });

            //this.storageService.updateRuns(flow.runs);
        }
        if (loadTriggers) {
            // Per-run trigger fetch — capped via the central helper. Runs that
            // already have triggerData are skipped without consuming a slot.
            const runsNeedingTriggers = runs.filter((run) => !run.triggerData);
            await mapWithConcurrency(runsNeedingTriggers, async (run) => {
                try {
                    const triggerOutput = await this.getFlowRunTrigger(run);
                    run.triggerData = triggerOutput;
                    run.error = null;
                } catch (reason) {
                    run.error = reason;
                }
            });
        }
        await this.storageDexieService.putRuns(runs);

        if (!silent) {
            this.serviceStatus$.next("");
        }
        flow.loading = false;
        return runs;
    }

    public async getFlowRuns2(environment: string, flowName: string, deep: boolean = false, loadTriggers: boolean = false, admin: boolean = false, more: number = 0, silent = false): Promise<FlowRun[]> {
        // 403 retry: when a user-scope read is denied (typically
        // `ConnectionAuthorizationFailed` because the caller doesn't own the
        // flow's connection), retry once through the admin scope. Skipped
        // when admin is already true.
        if (!admin) {
            try {
                return await this.getFlowRuns2Inner(environment, flowName, deep, loadTriggers, false, more, silent);
            } catch (err: any) {
                const status = Number(err?.status || err?.error?.status || 0);
                const code = err?.error?.error?.code || '';
                const looksLikeAuthFailure = status === 403 ||
                    status === 401 ||
                    code === 'ConnectionAuthorizationFailed' ||
                    code === 'AuthorizationFailed';
                if (!looksLikeAuthFailure) throw err;
                console.warn(`[runs] ${flowName} returned ${status} ${code}; retrying with admin scope`);
                return await this.getFlowRuns2Inner(environment, flowName, deep, loadTriggers, true, more, silent);
            }
        }
        return await this.getFlowRuns2Inner(environment, flowName, deep, loadTriggers, true, more, silent);
    }

    /** Original implementation — see `getFlowRuns2` for the public wrapper that
     *  adds 403-retry-with-admin on top. */
    private async getFlowRuns2Inner(environment: string, flowName: string, deep: boolean, loadTriggers: boolean, admin: boolean, more: number, silent: boolean): Promise<FlowRun[]> {
        let runs: FlowRun[] = [];
        var retry = true;
        var nextLink = '';
        var filter = '';
        var prev: string | null = null;

        //let flow:Flow = clone ? {..._flow} : _flow;

        // var cacheRuns: FlowRun[] = flow.runs;

        // if (cacheRuns && cacheRuns.length) {

        //     cacheRuns = cacheRuns.filter(run=>!!run.startTime);

        //     if (!deep) {
        //         prev = cacheRuns[0].startTime.toISOString();
        //         filter = `&$filter=startTime gt ${prev} `
        //     }

        //     //runs.push(...cacheRuns);
        // }
        // if (flow.checkRuns == -1) {
        //     if (deep || loadTriggers || more) {
        //         // continue
        //     }
        //     else {
        //         return [];
        //     }
        // }

        // if (flow.flowState == "Deleted") {
        //     return [];
        // }
        // if (more && flow.more) {
        //     nextLink = flow.nextLink;
        // }

        var adminScope = admin ? 'scopes/admin/' : '';
        var adminV2 = admin ? '/v2' : '';

        // flow.loading = true;

        while (retry) {

            if (!silent) {
                this.serviceStatus$.next(`Fetching Flow runs`);
            }

            var batch:FlowRun[] = await this.sendRequest(`${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${environment}/flows/${flowName}/runs?api-version=${API_VERSION}&$expand=properties/trigger${filter}${nextLink}`, {
                method: "GET"
            }).pipe(
                
                catchError(res=>{
                    if (admin && res.error && res.error.error && res.error.error.code == "FlowNotFound") {
                        this.markAdminFlowsDeleted(environment, [flowName]).catch((error) => {
                            console.warn('[FlowManagementService] failed to mark admin flow deleted from run lookup', error);
                        });
                        return [];
                    }
                    return throwError(res);
                }),
                
                map((response: any) => {

                if (deep) {
                    retry = true;
                }
                if (more > 0) {
                    retry = true;
                    more--;
                }

                if (response.nextLink) {
                    // nextLink = decodeURIComponent(response.nextLink);
                    // var m = /(\$skiptoken=.*?)(\&|$)/gi.exec(nextLink);
                    let next = response.nextLink
                    let m = /(%24skiptoken=.*?)(\&|$)/gi.exec(next);
                    if (m) {
                        //nextLink = '&' + m[1].replace('+', '%2B');
                        nextLink = `&${m[1]}`;
                        // flow.nextLink = nextLink;
                    }
                }
                else {
                    // out of pages
                    retry = false;
                    // "providers/Microsoft.ProcessSimple/environments/Default-26e65220-5561-46ef-9783-ce5f20489241/flows/9e00ea27-9f05-4e3b-a86e-3f12ae9d9235/runs?api-version=2016-11-01&%24skiptoken=eyJuZXh0UGFydGl0aW9uS2V5IjoiMSE4IVJqUTBPVFUtIiwibmV4dFJvd0tleSI6IjEhODQhTWtJeFFVTTJRemN3T1RjME5ESTJRVGxDUmpaRE9FUTRNRUZGTlVRMU16TmZNRGcxT0RZM05EWTRNVFF5TlRReU5USTROakl3TWpRME16RXlPVEEtIn0%3d"
                }

                if (more == 0 && !deep) {
                    // more - reads next page so it's finished, unless we are on deep
                    retry = false;
                }

                let runs = response.value.map((item: any) => {
                    var run = new FlowRun(item);
                    run.flowName = flowName;
                    run.environment = environment;
                    return run;
                });

                // flow.setNextScan(runs.length);

                if (prev) {
                    runs = runs.filter((item: FlowRun) => item.startTime && item.startTime.toISOString() > prev || item.endTime && item.endTime.toISOString() > prev);
                }
                return runs;
            })).pipe(catchError(err => {
                if (!silent) {
                    this.serviceStatus$.next(`Error Fetching Flow Runs: ${err.status}`);
                }
                throw err;
            })).toPromise();

            if (!batch || !batch.length) {
                break;
            }

            // batch.forEach((value: FlowRun) => {
            //     var index = cacheRuns.findIndex(value1 => value1.name == value.name);
            //     if (index != -1) {
            //         cacheRuns[index] = value;
            //     }
            // });

            // batch = batch.filter((value: FlowRun) => {
            //     return cacheRuns.findIndex(value1 => value1.name == value.name) == -1;
            // });

            if (batch.length) {
                runs.push(...batch);
            }

            // limitation set in indexdb
            // if (runs.length > 2000) {
            //     break;
            // }

            // if (retry && runs.length >= 50 ) {
            //     retry = false;
            // }
        }

        // if (loadTriggers) {
        //     // load history


        //     // https://australia.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-eadd1a95-7e83-457f-8177-6aed1fa73f2a/flows/ced8b72f-7ebe-4cef-b5af-33517386ed5a
        //     // /triggers/When_an_item_is_created_or_modified/histories?api-version=2016-11-01&id=@id&$expand=properties%2Frun%2Fproperties&$top=40&$filter=Status%20eq%20%27failed%27

        //     //var triggers =
        //     await this.getFlowTriggers(flow, admin).then(triggers => {

        //         if (!triggers || !triggers.value || !triggers.value.length) {
        //             return;
        //         }

        //         //if (triggers && triggers.value && triggers.value.length && triggers.value[0].name) {
        //         return this.getFlowTriggerHistory(flow, triggers.value[0].name).then(histories => {

        //             if (histories && histories.value.length) {
        //                 var failedTriggers = histories.value.map(item => {
        //                     var run = new FlowRun(item);
        //                     run.flowName = flow.flowName;
        //                     run.environment = flow.environment;
        //                     run.triggerName = triggers.value[0].name;
        //                     run.status += " (trigger)";
        //                     return run;
        //                 });

        //                 failedTriggers = failedTriggers.filter((value: FlowRun) => {
        //                     return cacheRuns.findIndex(value1 => value1.name == value.name) == -1;
        //                 });

        //                 if (failedTriggers.length) {
        //                     runs.push(...failedTriggers);
        //                 }
        //             }
        //             return flow.runs;
        //         });
        //         //}
        //     });

        // }

        // if (runs && runs.length) {
        //     flow.runs.push(...runs);
        //     flow.runs.sort((a, b) => (b.startTime ? b.startTime.getTime() : 0) - (a.startTime ? a.startTime.getTime() : 0));

        //     // flow.runs.reduce((cur, next:FlowRun)=>{
        //     //     return cur.then(()=>{
        //     //         if (next.triggerData) {
        //     //             return Promise.resolve();
        //     //         }
        //     //         else {
        //     //             var p = this.getFlowRunTrigger(next);
        //     //             p.then((triggerOutput)=>{
        //     //                 next.triggerData = triggerOutput;
        //     //             });
        //     //             return p;
        //     //         }
        //     //     });
        //     // }, Promise.resolve()).then(()=>{
        //     //     //all executed
        //     // });

        //     //this.storageService.updateRuns(flow.runs);
        // }
        // if (loadTriggers) {
        //     var pTriggers = []
        //     flow.runs.forEach(run => {
        //         if (run.triggerData) {
        //             return;
        //         }
        //         var p = this.getFlowRunTrigger(run).then(triggerOutput => {
        //             run.triggerData = triggerOutput;
        //             run.error = null;
        //         }).catch((reason) => {
        //             run.error = reason;
        //             return null;
        //         });
        //         pTriggers.push(p);
        //     });

        //     await Promise.all(pTriggers);
        // }

        // if (!silent) {
        //     this.serviceStatus$.next("");
        // }
        // flow.loading = false;
        return runs;
    }

    public cancelFlowRun(run: FlowRun): Observable<any> {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${run.environment}/flows/${run.flowName}/runs/${run.name}/cancel?api-version=${API_VERSION}`, {
            method: "POST"
        });
    }

    public deleteFlowRun(run: FlowRun, admin = true): Observable<any> {

        var adminScope = admin ? 'scopes/admin/' : '';

        //https://management.azure.com/subscriptions/87EBF366-F992-4B16-B96E-88E52F74F476/providers?api-version=2015-01-01

        // return this.sendRequest(`${this.API_ROOT}providers?api-version=${API_VERSION}`, {
        //     method: "GET"
        // });

        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${run.environment}/flows/${run.flowName}/runs/${run.name}?api-version=${API_VERSION}`, {
            method: "DELETE"
        });
    }

    public resubmit(run: FlowRun) {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${run.environment}/flows/${run.flowName}/triggers/${run.triggerName}/histories/${run.name}/resubmit?api-version=${API_VERSION}`, {
            method: "POST"
        });
    }

    public resetTrigger(flow: Flow) {

        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${flow.environment}/flows/${flow.flowName}/triggers/?api-version=${API_VERSION}`, {
            method: "GET"
        }).toPromise().then((triggerData) => {

            var promises = [];
            triggerData.value.forEach(trigger => {
                var p = this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${flow.environment}/flows/${flow.flowName}/triggers/${trigger.name}/reset?api-version=${API_VERSION}`, {
                    method: "POST"
                }).toPromise();

                promises.push(p);

            });
            return Promise.all(promises);
        });
    }

    // public setStateTrigger(flow: Flow) {

    //     return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${flow.environment}/flows/${flow.flowName}/triggers/?api-version=${API_VERSION}`, {
    //         method: "GET"
    //     }).toPromise().then((triggerData) => {

    //         var promises = [];
    //         triggerData.value.forEach(trigger => {
    //             var p = this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${flow.environment}/flows/${flow.flowName}/triggers/${trigger.name}/setState?api-version=${API_VERSION}`, {
    //                 method: "POST"
    //             }).toPromise();

    //             promises.push(p);

    //         });
    //         return Promise.all(promises);
    //     });
    // }

    public getFlowFromRun(runpath: string): Observable<any> {

        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${runpath}?$expand=properties%2Factions,properties%2Fflow&api-version=${API_VERSION}`, {
            method: "GET"
        }).pipe(map((runData: any) => {

            // var runs: FlowRunAction[] = [];

            // var a = new FlowRunAction(runData.properties.trigger);
            // a.runName = run.name;
            // runs.push(a);

            // var actions = runData.properties.actions;

            // Object.keys(actions).map(key => {

            //     a = new FlowRunAction(actions[key]);
            //     a.name = key;
            //     a.runName = run.name;
            //     runs.push(a);
            // });


            // runs.sort((b, a) => { return (b.startTime ? b.startTime.getTime() : 0) - (a.startTime ? a.startTime.getTime() : 0); });

            // return runs;
            return runData;
        }));

        // var actions = this.sendRequest(`${this.API_ROOT}providers/Microsoft.ProcessSimple/environments/${run.environment}/flows/${run.flowName}/runs/${run.name}/actions?api-version=${API_VERSION}`, {
        //     method: "GET"
        // }).pipe(map((response: any) => response.value.map(item => {
        //     var run = new FlowRunAction(item);
        //     return run;
        // })));
    }

    public getFlowRun(run: FlowRun): Observable<FlowRunAction[]> {

        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${run.environment}/flows/${run.flowName}/runs/${run.name}?$expand=properties%2Factions,properties%2Fflow&api-version=${API_VERSION}`, {
            method: "GET"
        }).pipe(map((runData: any) => {

            var runs: FlowRunAction[] = [];

            var a = new FlowRunAction(runData.properties.trigger);
            a.runName = run.name;
            runs.push(a);

            var actions = runData.properties.actions;

            Object.keys(actions).map(key => {

                a = new FlowRunAction(actions[key]);
                a.name = key;
                a.runName = run.name;
                runs.push(a);
            });


            runs.sort((b, a) => { return (b.startTime ? b.startTime.getTime() : 0) - (a.startTime ? a.startTime.getTime() : 0); });

            return runs;
        }));

        // var actions = this.sendRequest(`${this.API_ROOT}providers/Microsoft.ProcessSimple/environments/${run.environment}/flows/${run.flowName}/runs/${run.name}/actions?api-version=${API_VERSION}`, {
        //     method: "GET"
        // }).pipe(map((response: any) => response.value.map(item => {
        //     var run = new FlowRunAction(item);
        //     return run;
        // })));
    }

    public async getFlowRunTimeline(run: FlowRun): Promise<FlowRunAction[]> {
        // evalulate flow's actions - find Approval actions
        // get flow actions of this run

        // const _flow = await firstValueFrom(this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${run.environment}/flows/${run.flowName}?$expand=properties%2Factions,properties%2Fflow&api-version=${API_VERSION}`, {
        //     method: "GET"
        // }).pipe(map((flowData: any)=>{

        //     return flowData;
        // })));

        let _actions = [];

        const repetitions = await firstValueFrom(this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${run.environment}/flows/${run.flowName}/runs/${run.name}?$expand=properties%2Factions,properties%2Fflow&api-version=${API_VERSION}`, {
            method: "GET"
        }).pipe(map((runData: any)=>{

            const flow = runData.properties.flow;

            const actions = this.languageService.parse(flow.properties.definition);

            console.log(actions);

            const pRepetitions = actions.map((pair):Promise<any>=>{
                const {key:action, value} = pair;
                
                return firstValueFrom(this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${run.environment}/flows/${run.flowName}/runs/${run.name}/actions/${action}/repetitions?api-version=${API_VERSION}`, {
                    method: "GET"
                }).pipe(
                    catchError(()=>{
                        return firstValueFrom(this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${run.environment}/flows/${run.flowName}/runs/${run.name}/actions/${action}?api-version=${API_VERSION}`, {
                            method: "GET"
                        }).pipe(
                            catchError(()=>of(null)
                        )));  
                    }),
                    map((data)=>{    
                        if (data) {
                            if (data.value) {
                                _actions.push( ... data.value);
                            }
                            else {
                                _actions.push( data);
                            }
                        }
                        return data;
                    })
                ));  
            });

            return pRepetitions;
            //return runData;

        })));
        
        await Promise.all(repetitions);

        // get approval action inside iterations
        // get approval action outside iterations

        // combine timeline list
        return _actions.map((action)=> new FlowRunAction(action));

    }

    public executeFlow(flow: Flow, body = {}): Observable<any>{
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${flow.environment}/flows/${flow.flowName}/run?api-version=${API_VERSION}`, {
            method: "POST",
            body: body
        });
    }

    public async getApprovalByOwner(environment: string, owner: string): Promise<any> {
        // https://australia.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments
        // /Default-26e65220-5561-46ef-9783-ce5f20489241/approvals?api-version=2016-11-01

        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/approvals?api-version=${API_VERSION}&$filter=properties/owner/id eq '${owner}' and properties/status eq 'Pending'&$expand=properties/requestSummary`, {
            method: "GET"
        }).pipe(map((response: any) => {
            return response.value;
        })).toPromise();
    }

    public async getApprovalViews(environment: string): Promise<any> {
        // https://australia.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments
        // /Default-26e65220-5561-46ef-9783-ce5f20489241/approvalViews?api-version=2016-11-01&$filter=properties%2FisActive%20eq%20%27false%27%20and%20properties%2FuserRole%20eq%20%27Approver%27

        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/approvalViews?api-version=${API_VERSION}&$filter=properties/isActive eq 'true' and (properties/userRole eq 'Approver' or properties/userRole eq 'Owner')`, {
            method: "GET"
        }).toPromise();
    }

    public async getApproval(environment: string, approval: string, owner: string): Promise<any> {

        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/approvals/${approval}?api-version=${API_VERSION}&$filter=properties/owner/id eq '${owner}'&$expand=requestSummary`, {
            method: "GET"
        }).toPromise();
    }

    public async getApprovals(environment: string): Promise<ApprovalRequest[]> {

        // var userId = this.getCurrentUser()['idToken']['oid'];//.then(user => user.profile);
        const user:any = this.getCurrentUser();
        //var userId = await this.authService.getUser();
        const { oid:userId } = user;

        var assignedTo = userId;

        var pApprovalRequests = this.getApprovalRequests(environment, assignedTo);
        return pApprovalRequests.then(requests => {

            // step here - get approvals by Owner to see who these are assigned to
            var owners = [userId];

            // owners = requests.map(request => request.raw.properties.approval.properties.owner.id).filter(distinct);
            // get each owner

            /*
            HttpErrorResponse: {"headers":{"normalizedNames":{},"lazyUpdate":null},"status":400,"statusText":"OK",
            "url":"https://api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-26e65220-5561-46ef-9783-ce5f20489241/approvals?api-version=2016-11-01&$filter=properties/owner/id%20eq%20%27e5b6b16b-e2cf-4e89-9d63-0b3b946a931f%27%20and%20properties/status%20eq%20%27Pending%27&$expand=properties/requestSummary","ok":false,"name":"HttpErrorResponse","message":"Http failure response for https://api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-26e65220-5561-46ef-9783-ce5f20489241/approvals?api-version=2016-11-01&$filter=properties/owner/id%20eq%20%27e5b6b16b-e2cf-4e89-9d63-0b3b946a931f%27%20and%20properties/status%20eq%20%27Pending%27&$expand=properties/requestSummary: 400 OK","error":{"error":{"code":"ListApprovalsFilterInvalidOwner","message":"The owner identity specified in $filter query properties/owner/id ('e5b6b16b-e2cf-4e89-9d63-0b3b946a931f') must match the caller identity ('36e3b856-3c2e-4605-ac5f-99064d229c3a'). Please utilize the approvalViews api for more advanced query capabilities."}}}
            */

            // Per-owner approvals fetch — capped via the central helper.
            return mapWithConcurrency(owners, (owner) => this.getApprovalByOwner(environment, owner)).then(results => {

                var approvals = [];
                results.forEach(r => {
                    approvals.push(...r)
                });

                var assigns: string[] = [];

                requests.forEach(r => {
                    r.approval = approvals.find(a => a.name == r.raw.properties.approval.name);
                    if (r.approval) {
                        assigns.push(...r.approval.properties.requestSummary.approvers.map(a => a.id));
                    }
                });

                // get unique assignto
                assigns = assigns.filter(distinct).filter(u => u != assignedTo);

                // Per-assignee approval requests fetch — capped via the central helper.
                return mapWithConcurrency(assigns, (assign) => this.getApprovalRequests(environment, assign)).then((results) => {

                    var otherRequests = []

                    results.forEach(rs => {
                        otherRequests.push(...rs);
                    });

                    requests.forEach(r => {
                        if (!r.approval) {
                            return;
                        }
                        r.approval.properties.requestSummary.approvers.forEach(a => {
                            if (a.id == assignedTo) {
                                a.approvalRequest = r;
                            }
                            else {
                                a.approvalRequest = otherRequests.find(or => or.raw.properties.assignedTo.id == a.id && or.raw.properties.approval.name == r.approval.name);
                            }
                        });
                    })

                    // do a big compare to figure out who hasn't done their approvalrequests

                    return requests;
                })

            });
        });
    }

    public async getApprovalRequests(environment: string, assignedTo: string, admin = false): Promise<ApprovalRequest[]> {

        let adminScope = admin ? 'scopes/admin/' : '';

        let filter = admin? '' : `&$filter=properties/assignedTo/id eq '${assignedTo}'`;

        const promise = this.sendRequest(`${this.API_ROOT}${this.PROVIDER}${adminScope}environments/${environment}/approvalRequests?api-version=${API_VERSION}${filter}&$expand=properties/approval,properties/approval/properties/requestSummary`, {
            method: "GET"
        }).pipe(map((response: any) => {
            return response.value.map(a => new ApprovalRequest(a));
        })).toPromise();
        return promise;
    }

    // https://australia.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-26e65220-5561-46ef-9783-ce5f20489241/approvals/73718138-8548-4453-a983-e8ce0562f618/cancel?api-version=2016-11-01
    public async cancelApproval(environment: string, approval: string): Promise<any> {
        return this.sendRequest(`${this.API_ROOT}${this.PROVIDER}environments/${environment}/approvals/${approval}/cancel?api-version=${API_VERSION}`, {
            method: "POST"
        }).pipe(map((response: any) => {
            return response;
        })).toPromise()
    }

    public getConnector(connection: Connection): Observable<any> {
        return this.sendRequest(`${this.API_PA_ROOT}${this.PA_PROVIDER}apis/${connection.connector}?api-version=${API_VERSION}&$filter=environment eq '${connection.environment}'`, {
            method: "GET"
        }).pipe(map((response: any) => {
            return response;
        }));
    }

    public getConnection(connection: Connection): Observable<any> {
        return this.sendRequest(`${this.API_PA_ROOT}${this.PA_PROVIDER}apis/${connection.connector}/connections/${connection.name}?api-version=${API_VERSION}&$filter=environment eq '${connection.environment}'`, {
            method: "GET"
        }).pipe(map((response: any) => {
            return response;
        }));
    }

    private isTokenUsable(tokenSecret: string, skewSeconds = 60): boolean {
        if (!tokenSecret) {
            return false;
        }

        try {
            const payload = this.decodeJwtPayload(tokenSecret);
            if (!payload) return true;

            if (!payload?.exp) {
                return true;
            }

            const now = Math.floor(Date.now() / 1000);
            return payload.exp > (now + skewSeconds);
        } catch {
            // If payload cannot be parsed, allow fallback token acquisition to proceed.
            return false;
        }
    }

    private decodeJwtPayload(token: string): any | null {
        const parts = token.split('.');
        if (parts.length < 2 || !parts[1]) return null;

        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
        const bytes = Uint8Array.from(atob(padded), c => c.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    }

    private async getPowerAppsTokenSecret(): Promise<string> {
        const scopesToTry = [
            ['https://service.powerapps.com/User']
        ];

        for (const scopes of scopesToTry) {
            const cached = await this.msalHelperService.getCachedTokenInternalAsync(scopes as string[]);
            if (cached?.secret) {
                return cached.secret;
            }
        }

        throw new Error('MSAL unauthorized: unable to acquire Power Apps access token for https://service.powerapps.com');
    }

    private async getFlowTokenSecret(): Promise<string> {
        const scopesToTry = [
            ['https://service.flow.microsoft.com//User']
        ];

        for (const scopes of scopesToTry) {
            const cached = await this.msalHelperService.getCachedTokenInternalAsync(scopes as string[]);
            if (cached?.secret) {
                return cached.secret;
            }
        }

        throw new Error('MSAL unauthorized: unable to acquire Flow access token for https://service.flow.microsoft.com');
    }

    private async getPowerAutomateTokenSecret(preferAdmin = false): Promise<string> {
        const scopes = preferAdmin
            ? ['https://service.powerapps.com/User']
            : ['https://service.flow.microsoft.com//Flows.Manage.All'];

        const cached = await this.msalHelperService.getCachedTokenInternalAsync(scopes);
        if (cached?.secret) {
            return cached.secret;
        }

        throw new Error(`MSAL unauthorized: unable to acquire ${preferAdmin ? 'PowerApps admin' : 'Power Automate'} access token`);
    }

    private toCachedUserItem(tenantId: string, oid: string, displayName: string, email: string, emails: string[] = []): UserItem | null {
        if (!oid) {
            return null;
        }

        const key = tenantId ? `${tenantId}.${oid}` : oid;
        return {
            key,
            displayName: displayName || email || oid,
            email: email || '',
            emails: mergeEmails(emails, email || ''),
        };
    }

    /**
     * Pre-populate the users table with every owner OID seen on a flow listing.
     * Writes are minimal placeholders (key + empty displayName/email/emails).
     * The OPFS putUsers merge logic preserves richer data from later enrichment
     * passes (getMakers, getConnectionsUser/Admin) — empty incoming fields
     * fall back to whatever's already stored.
     */
    private async cacheUsersFromFlows(flows: Flow[]): Promise<UserItem[]> {
        const tenantId = this.getCurrentUser()?.tenantId || '';
        const oids = new Set<string>();
        for (const flow of flows || []) {
            // Owners surfaced by the flow API as Dataverse principals.
            for (const oid of flow.shareOwners || []) {
                if (oid) oids.add(oid);
            }
        }
        if (oids.size === 0) return [];
        const users: UserItem[] = [...oids].map((oid) => ({
            key: tenantId ? `${tenantId}.${oid}` : oid,
            displayName: '',
            email: '',
            emails: [],
        }));
        await this.storageDexieService.putUsers(users);
        return users;
    }

    /**
     * Direct-browser maker lookup. Makers are derived from the
     * `properties.createdBy` field on connections, so we reuse the direct
     * connections fetcher and pull the userItems out of the same parse pass
     * the disabled server-mediated path used.
     */
    private async getMakersDirect(environment: string, adminOnly: boolean): Promise<UserItem[]> {
        const adminScope = adminOnly ? 'scopes/admin/' : '';
        const apiVersion = '2017-06-01';
        const all: any[] = [];
        let nextLink = '';
        const PAGE_LIMIT = 50;
        let pages = 0;

        try {
            while (pages < PAGE_LIMIT) {
                const url = nextLink
                    ? nextLink
                    : `${this.API_PA_ROOT}${this.PA_PROVIDER}${adminScope}connections?` +
                      `$filter=environment+eq+%27${encodeURIComponent(environment)}%27&` +
                      `api-version=${apiVersion}`;
                const response: any = await firstValueFrom(
                    this.sendRequest(url, { method: 'GET' }).pipe(timeout(60 * 1000))
                );
                all.push(...((response?.value || []) as any[]));
                nextLink = response?.nextLink || response?.['@odata.nextLink'] || '';
                pages++;
                if (!nextLink) break;
            }
        } catch (err) {
            console.warn(`[makers.direct] paginated connections fetch failed at page ${pages}; using what we have`, err);
        }

        const { userItems } = this.parseConnectionsAndExtractUsers({ connections: all });
        console.log(`[makers.direct] extracted ${userItems.length} makers from ${all.length} connections (${pages} page${pages === 1 ? '' : 's'})`);

        if (userItems.length > 0) {
            try {
                await this.storageDexieService.putUsers(userItems);
            } catch (err) {
                console.error('[makers.direct] putUsers threw', err);
            }
        }
        return userItems;
    }

    public async getMakers(environment: string, adminOnly = false): Promise<UserItem[]> {
        // Deprecated: never route maker lookup through FlowStudio `/api/makers`.
        // The batching toggle now means Microsoft's browser-side batch endpoint,
        // so makers are derived directly from connections.
        const batchingEnabled = false;
        const tokenSecret = batchingEnabled ? await this.getPowerAppsTokenSecret() : null;

        if (!batchingEnabled || !tokenSecret) {
            return this.getMakersDirect(environment, adminOnly);
        }

        const workspace = (localStorage.getItem('workspace') || '').trim();
        const headers: Record<string, string> = {
            'Content-Type': 'application/json',
            'x-authorization': `Bearer ${tokenSecret}`
        };
        if (workspace) {
            headers['x-workspace'] = workspace;
        }

        let response: any;
        try {
            response = await firstValueFrom(
                this.httpClient.post('/api/makers', {
                    environment,
                    adminOnly,
                    ...(workspace ? { workspace } : {})
                }, { headers: new HttpHeaders(headers) }).pipe(timeout(120 * 1000))
            );
        } catch (err) {
            console.warn('[makers.api] disabled /api/makers path failed; using direct maker lookup', err);
            return this.getMakersDirect(environment, adminOnly);
        }

        const tenantId = this.getCurrentUser()?.tenantId || '';
        const currentUser = this.getCurrentUser();
        const currentOid: string = (currentUser as any)?.oid || currentUser?.idTokenClaims?.['oid'] || '';
        const jwtEmail: string = (currentUser?.idTokenClaims?.['email'] as string) || '';
        const jwtUpn: string = currentUser?.username || '';

        let users = ((response?.makers || []) as any[])
            .map((maker) => this.toCachedUserItem(
                maker?.tenantId || tenantId,
                maker?.oid || '',
                maker?.displayName || '',
                maker?.email || '',
                maker?.emails || [],
            ))
            .filter((user): user is UserItem => !!user)
            .filter((user, index, items) => items.findIndex((item) => item.key === user.key) === index);

        // For the current logged-in user's own record, promote both JWT emails
        // (friendly alias + UPN) to ensure both forms resolve via getUserByEmail.
        if (currentOid) {
            const selfKey = tenantId ? `${tenantId}.${currentOid}` : currentOid;
            users = users.map((user) => {
                if (user.key !== selfKey) return user;
                const selfEmails = mergeEmails(user.emails, jwtEmail);
                if (jwtUpn && !selfEmails.includes(jwtUpn)) selfEmails.push(jwtUpn);
                // Prefer the friendly email (from JWT 'email' claim) as primary display
                const primaryEmail = jwtEmail || user.email;
                return { ...user, email: primaryEmail, emails: selfEmails };
            });
        }

        if (users.length > 0) {
            await this.storageDexieService.putUsers(users);
        }

        return users;
    }

    public async getConnectionsUser(environment: string): Promise<Connection[]> {
        return this.getConnectionsScoped(environment, /* admin */ false);
    }

    public async getConnectionsAdmin(environment: string): Promise<Connection[]> {
        return this.getConnectionsScoped(environment, /* admin */ true);
    }

    /**
     * Unified entry point for connections. The old `/api/connections` proxy
     * path is disabled; the active path reads directly from api.powerapps.com
     * so the browser stays region-independent.
     */
    private async getConnectionsScoped(environment: string, admin: boolean): Promise<Connection[]> {
        const scopeLabel = admin ? 'admin-scope' : 'user-scope';
        const batchingEnabled = false;

        if (batchingEnabled) {
            const tokenSecret = await this.getPowerAppsTokenSecret();
            if (tokenSecret) {
                const workspace = (localStorage.getItem('workspace') || '').trim();
                const headers: Record<string, string> = {
                    'Content-Type': 'application/json',
                    'x-authorization': `Bearer ${tokenSecret}`,
                };
                if (workspace) headers['x-workspace'] = workspace;

                let response: any;
                try {
                    response = await firstValueFrom(
                        this.httpClient.post('/api/connections', {
                            environment,
                            sources: admin ? ['admin'] : ['my/shared'],
                            ...(workspace ? { workspace } : {}),
                        }, { headers: new HttpHeaders(headers) }).pipe(timeout(120 * 1000))
                    );
                } catch (err) {
                    console.warn(`[connections.api] ${scopeLabel}: disabled /api/connections path failed; using direct reads`, err);
                    return this.getConnectionsDirect(environment, admin);
                }

                const { connections, userItems } = this.parseConnectionsAndExtractUsers(response);
                response = null;
                console.log(`[connections.api] ${scopeLabel}: ${connections.length} connections + ${userItems.length} users`);

                if (userItems.length > 0) {
                    try {
                        await this.storageDexieService.putUsers(userItems);
                    } catch (err) {
                        console.error(`[connections.api] ${scopeLabel}: putUsers threw`, err);
                    }
                }

                try {
                    await this.storageDexieService.putConnections(connections, environment, admin ? 'admin' : 'user');
                } catch (err) {
                    console.error(`[connections.api] ${scopeLabel}: putConnections threw`, err);
                }

                // Record per-source freshness so the header reload-button on
                // /connections can show "Refreshed Xm ago" against the right clock.
                await this.storageDexieService
                    .markEnvSourceScanned(environment, admin ? 'connectionsAdmin' : 'connections', connections.length)
                    .catch((err) => console.warn(`[connections.api] ${scopeLabel}: markEnvSourceScanned failed`, err));

                return connections;
            }
            console.warn(`[connections.api] ${scopeLabel}: missing Power Apps token for disabled proxy path; using direct reads`);
        }

        return this.getConnectionsDirect(environment, admin);
    }

    /**
     * Direct-browser connections fetch — paginated calls to api.powerapps.com.
     * Used when batching is OFF (default) or when the batched call fails.
     * Reuses parseConnectionsAndExtractUsers so the user extraction is identical
     * to the batched path.
     */
    private async getConnectionsDirect(environment: string, admin: boolean): Promise<Connection[]> {
        const scopeLabel = admin ? 'admin-scope' : 'user-scope';
        const adminScope = admin ? 'scopes/admin/' : '';
        const apiVersion = '2017-06-01';
        const all: any[] = [];
        let nextLink = '';
        const PAGE_LIMIT = 50;
        let pages = 0;

        try {
            while (pages < PAGE_LIMIT) {
                const url = nextLink
                    ? nextLink
                    : `${this.API_PA_ROOT}${this.PA_PROVIDER}${adminScope}connections?` +
                      `$filter=environment+eq+%27${encodeURIComponent(environment)}%27&` +
                      `api-version=${apiVersion}`;
                const response: any = await firstValueFrom(
                    this.sendRequest(url, { method: 'GET' }).pipe(timeout(60 * 1000))
                );
                const value = (response?.value || []) as any[];
                all.push(...value);
                nextLink = response?.nextLink || response?.['@odata.nextLink'] || '';
                pages++;
                if (!nextLink) break;
            }
        } catch (err) {
            console.warn(`[connections.direct] ${scopeLabel}: paginated fetch failed at page ${pages}; returning what we have`, err);
        }

        // Normalise to the shape parseConnectionsAndExtractUsers expects.
        const { connections, userItems } = this.parseConnectionsAndExtractUsers({ connections: all });
        console.log(`[connections.direct] ${scopeLabel}: ${connections.length} connections + ${userItems.length} users (${pages} page${pages === 1 ? '' : 's'})`);

        if (userItems.length > 0) {
            try {
                await this.storageDexieService.putUsers(userItems);
            } catch (err) {
                console.error(`[connections.direct] ${scopeLabel}: putUsers threw`, err);
            }
        }

        try {
            await this.storageDexieService.putConnections(connections, environment, admin ? 'admin' : 'user');
        } catch (err) {
            console.error(`[connections.direct] ${scopeLabel}: putConnections threw`, err);
        }

        // Record per-source freshness so the header reload-button on
        // /connections can show "Refreshed Xm ago" against the right clock.
        await this.storageDexieService
            .markEnvSourceScanned(environment, admin ? 'connectionsAdmin' : 'connections', connections.length)
            .catch((err) => console.warn(`[connections.direct] ${scopeLabel}: markEnvSourceScanned failed`, err));

        return connections;
    }

    /**
     * Single-pass parse of an /api/connections response: builds Connection objects
     * AND extracts a deduped list of UserItem placeholders from each row's
     * `properties.createdBy`. We do this inline before the response is dropped so
     * we don't have to keep `connection.raw` alive on every Connection (which on
     * large tenants was the OOM source on /connections).
     */
    private parseConnectionsAndExtractUsers(
        response: any
    ): { connections: Connection[]; userItems: UserItem[] } {
        const rawList = response?.connections || [];
        const tenantId = this.getCurrentUser()?.tenantId || '';
        const connections: Connection[] = new Array(rawList.length);
        const seenUserKeys = new Set<string>();
        const userItems: UserItem[] = [];
        for (let i = 0; i < rawList.length; i++) {
            const c = rawList[i];
            connections[i] = new Connection(c);
            const cb = c?.properties?.createdBy;
            if (!cb) continue;
            const oid = cb.id || cb.objectId || cb.principalId || cb.oid || '';
            if (!oid) continue;
            const key = tenantId ? `${tenantId}.${oid}` : oid;
            if (seenUserKeys.has(key)) continue;
            seenUserKeys.add(key);
            const email = cb.email || cb.userPrincipalName || cb.upn || cb.mail || '';
            userItems.push({
                key,
                displayName: cb.displayName || cb.name || cb.userPrincipalName || cb.email || '',
                email,
                emails: mergeEmails([], email),
            });
        }
        rawList.length = 0;
        return { connections, userItems };
    }

    public async getConnections(environment: string): Promise<Connection[]> {
        // Default to user-scope connections for backward compatibility
        return this.getConnectionsUser(environment);

        // https://api.powerapps.com/providers/Microsoft.PowerApps/connections?
        // $expand=permissions($filter%3dmaxAssignedTo(%2736e3b856-3c2e-4605-ac5f-99064d229c3a%27))&
        // $filter=environment+eq+%27Default-26e65220-5561-46ef-9783-ce5f20489241%27&
        // api-version=2017-06-01&
        // $skiptoken=eyJmYWlsdXJlRm91bmQiOmZhbHNlLCJsYXN0UmVnaXN0cmF0aW9uU2VlbiI6InNoYXJlZCIsImxhc3RDb250aW51YXRpb25Ub2tlblNlZW4iOiJleUpRU3lJNklqRWhPQ0ZTVlU1SFRtdEZMU0lzSWxKTElqb2lNU0V5TWpRaFRXcGFSazVxVlhsTmFrRTJUV3RSTVU1VVdYaFBha3BGVGtSYVJsSnFiM2xTUkdzelQwUk5OazFyVWtSU1ZGWkhUV3BCTUU5RWEzbE9SRVptVlVWR1JGUnBNSHBPYTFWNlVXcG5NVTVxYjNsU1JFNUVUV3RWTmsxclVUQk9ha0V4VDJwS1JWRlZUVEZTYW05NVVrUnJOVTFFV1RCU1JFbDVUMVZOZWxGVE1VSldWazVWVld0R1RWTlZSVFpOYTFGM1RVUkZkRlJGT1VoVFZVNUhWRVU1V0ZWNU1IcE5hMUV3VFZSR1IwNTZiM2xTUkZsNVRsUk5OazFyVVRCT1ZWazBUMnBLUlZGVVFUTk9lbTk1VWtWSmQxSlZWVFJQUlUwd1VXdEZkMUYzTFMwaUxDSlBTVVFpT2lJek5tVXpZamcxTmkwell6SmxMVFEyTURVdFlXTTFaaTA1T1RBMk5HUXlNamxqTTJFaWZRPT0ifQ%3d%3d&
        // $paginationId=f5b22542-3463-4d47-a576-96a8556edd14


        // https://api.powerapps.com/providers/Microsoft.PowerApps/apis?
        // showApisWithToS=true?$expand=permissions($filter=maxAssignedTo(%2736e3b856-3c2e-4605-ac5f-99064d229c3a%27))&$filter=environment%20eq%20%27Default-26e65220-5561-46ef-9783-ce5f20489241%27&api-version=2017-06-01
    }

    public updateConnection(connection: Connection, definition: any): Observable<any> {
        return this.sendRequest(`${this.API_PA_ROOT}${this.PA_PROVIDER}apis/${connection.connector}/connections/${connection.name}?api-version=${API_VERSION}&$filter=environment eq '${connection.environment}'`, {
            method: "PATCH",
            body: definition
        }).pipe(map((response: any) => {
            return response;
        }));
    }

    public async getEvents2(environment: string, prev: Date = null /*, cachedFlows: Flow[] = []*/) {
        var next: Date = null;
        //var prev: Date = null;
        var skip: string = "";

        if (prev == null) {
            prev = new Date();
            prev.setDate(prev.getDate()-30);
        }

        while (true) {
            var batch: string[] = null;
            var saves = [];

            if (prev) {
                prev.setHours(prev.getHours(), 0, 0, 0);
            }
            if (next) {
                next.setHours(next.getHours(), 0, 0, 0);
            }

            try {
                batch = await this.sendRequest(
                    `${this.API_ROOT}${this.PROVIDER}environments/${environment}/events?api-version=${API_VERSION}` +
                    "&$aggregate=Fail,Success" +
                    //"&$expand=Runs" +
                    `&$filter=Timestamp ge ${prev.toISOString()} ` +
                    //" and Type eq 'Success' " +
                    skip +
                    ((next) ? ` and Timestamp lt ${next.toISOString()} ` : "") +
                    " and Type ne 'PushNotification'" +
                    "&$top=250", {
                        method: "GET"
                    }).pipe(map((response: any) => response.value.map(item => {

                        const { actorId, object, type, timestamp } = item.properties;

                        // if (type == 'AggregatedSuccess') {
                        //     const { count, runFailureCount, triggerFailureCount, isflowDeleted, fromTimestamp, toTimestamp } = object;
                        //const flow = cachedFlows.find((f)=>f.flowName == actorId);
                        saves.push(actorId);

                        //     // flow.runsCount = count;
                        //     // flow.runsFailCount = runFailureCount;
                        //     //flow.triggerFailCount = triggerFailureCount;
                        //     // flow.lastRunTimestamp = timestamp;

                        //     // const from = new Date(fromTimestamp);
                        //     // const to = new Date(toTimestamp);

                        //     // flow.runsEstimate = count / (from.getDate() - to.getDate());

                        //     // if (isflowDeleted == true) {
                        //     //     flow.flowState = "Deleted";
                        //     // }

                        //     saves.push(flow);
    
                        // }

                        return actorId;

                        // var run = new FlowRun(item);
                        // run.environment = environment;
                        // return run;
                    })), catchError((err, caught) => {

                        var e = err;
                        //debugger;
                        return [];
                    })).toPromise();
            }
            catch {
                break;
            }

            await this.getRuns(environment, saves);

            // var promises: Promise<any>[] = []
            // if (saves.length > 0) {

            //     const pFlows = saves.map((flowName: string)=>{
            //         const pRuns = this.getFlowRuns2(environment, flowName).then((runs)=>{

            //             return this.storageDexieService.putRuns(runs);
            //             // flow.runs = runs.map((run)=>{
            //             //     const { startTime, endTime, status } = run;
            //             //     return new FlowRun({
            //             //         startTime, endTime, status
            //             //     });
            //             // });
            //             // return flow;
            //         });
            //         return pRuns;
            //     })

            //     promises.push(...pFlows);
            // }
            // const flows = await Promise.all(promises);
            //await this.storageDexieService.putFlows(flows);

            // events doesn't seem to support pagination
            break;
        }
    }

    public async getRuns(environment: string, flowNames: string[], admin = false) {
        const ordered = Array.from(new Set((flowNames || []).filter(Boolean)));
        const groups = [{ label: 'default', flowNames: ordered }];
        return this.getRunsInGroups(environment, groups, admin);
    }

    public async getUsers(users: string[]) {
        // fetch user name/emails from AAD, store in dexie. Per-user Graph
        // fan-out is capped via the central concurrency helper.
        const all = await mapWithConcurrency(users || [], async (userid) => {
            return await this.getUser(userid) as UserItem;
        });
        await this.storageDexieService.putUsers(all);
        return all;
    }

    public async getEvents(environment: string, prev: Date = null, cachedFlows: Flow[] = []): Promise<FlowRun[]> {
        var runs: FlowRun[] = [];
        var next: Date = null;
        //var prev: Date = null;
        var skip: string = "";

        if (prev == null) {
            prev = new Date();
            prev.setDate(prev.getDate()-30);
        }

        /*
        https://australia.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-26e65220-5561-46ef-9783-ce5f20489241/events?api-version=2016-11-01&$aggregate=Fail&$expand=Runs&$filter=Timestamp ge 2019-05-13T14:00:00.000Z and Type ne 'Success' and Type ne 'PushNotification'

        https://australia.api.flow.microsoft.com/providers/Microsoft.ProcessSimple/environments/Default-26e65220-5561-46ef-9783-ce5f20489241/flows/9b55ebd1-37fb-4d80-a620-9984604f2f3e/triggers/When_a_new_email_arrives/histories?api-version=2016-11-01&id=@id&$expand=properties/run/properties&$top=40&$filter=Status eq 'failed'
        */

        let filter = '';
        var cacheRuns: FlowRun[] = [] //await this.storageService.getRuns(environment);
        if (cacheRuns.length) {
            cacheRuns.sort((a, b) => { return (b.startTime ? b.startTime.getTime() : 0) - (a.startTime ? a.startTime.getTime() : 0); });
            /*date =*/ prev = cacheRuns[0].startTime; //.toISOString();

            //skip = ` and Timestamp ge ${prev} `

            runs.push(...cacheRuns);
        }

        cachedFlows.filter(f => /*f.checkRuns != -1 &&*/ f.runsCount > 50).forEach(f => {
            skip += ` and actorId ne '${f.flowName}' `
        });

        while (true) {
            var batch: FlowRun[] = null;

            if (prev) {
                prev.setHours(prev.getHours(), 0, 0, 0);
            }
            if (next) {
                next.setHours(next.getHours(), 0, 0, 0);
            }

            try {
                batch = await this.sendRequest(
                    `${this.API_ROOT}${this.PROVIDER}environments/${environment}/events?api-version=${API_VERSION}` +
                    "&$aggregate=Fail,Success" +
                    //"&$expand=Runs" +
                    `&$filter=Timestamp ge ${prev.toISOString()} ` +
                    //" and Type eq 'Success' " +
                    skip +
                    ((next) ? ` and Timestamp lt ${next.toISOString()} ` : "") +
                    " and Type ne 'PushNotification'" +
                    "&$top=5", {
                        method: "GET"
                    }).pipe(map((response: any) => response.value.map(item => {
                        var run = new FlowRun(item);
                        run.environment = environment;
                        return run;
                    })), catchError((err, caught) => {

                        var e = err;
                        //debugger;
                        return [];
                    })).toPromise();
            }
            catch {
                break;
            }

            if (next) {
                batch = batch.filter((item) => { return item.startTime < next; });
                // looking for old stuff
            }

            if (!batch || batch.length == 0) {
                break;
            }

            //var fails = batch.filter((item) => { return item.status == "Failed" });

            // batch = batch.filter( run=> {
            //     return cachedFlows.filter(f=>f.checkRuns==-1 && f.flowName == run.flowName).length > 0;
            // });

            var grouped = groupBy(batch, 'flowName');
            Object.keys(grouped).forEach(element => {
                //if (grouped[element].length > 50) {
                skip += ` and actorId ne '${element}' `
                //}
            });

            runs.push(...batch);

            next = batch[batch.length - 1].startTime;
        }

        var newRuns: FlowRun[] = [];
        if (prev) {
            newRuns = runs.filter(item => item.startTime > prev);
            //await this.storageService.updateRuns(newRuns);
        }
        else {
            //await this.storageService.updateRuns(runs);
        }

        return runs;
    }

    private sendRequest(url: string, options: any): Observable<any> {

        // make a copy
        //let options1 = Object.assign(new RequestOptions(), options);
        const retryWaitMilliSeconds = 5*1000;
        const retryCount = 3;

        const req = this.httpClient.request(options.method as string, url, options);
        const req1 = req.pipe(retryWhen(error =>
          error.pipe(
            concatMap((error, count) => {
              if (count <= retryCount && [503, 504].includes(error.status)) {
                // retry server error or server gateway timeout

                return of(error);
              }
              return throwError(error);
            }),
            delay(retryWaitMilliSeconds)
          )
        ));

        return req1; /* .catch((err: HttpErrorResponse) => {
            // simple logging, but you can do a lot more, see below
            // console.error('An error occurred:', err.error);

            var userName = this.getCurrentUser().displayableId;
            let error = err.error || err;
            if (error && error.error && error.error.code == "FlowNotFound") {
                return throwError(err);
            }
            var body = Object.assign({
                "logon": userName,
                "environment": this.currentEnvironment,
                "url": url
            }, {
                "error": error
            });

            let p = this.httpClient.post('https://prod.flowstudio.app/log', body);
            return p.flatMap(()=>throwError(err));
        });
        */
        /*.pipe(map(this.extractData) /*, catchError(this.handleError) ) */;
        // if (url.startsWith(this.API_ROOT)) {
        //     resource = 'https://service.flow.microsoft.com/';
        // }
        // if (url.startsWith(this.API_PA_ROOT)) {
        //     resource = 'https://service.powerapps.com/';
        // }

        // let resource = this.adalService.GetResourceForEndpoint(url);
        // let authenticatedCall: any;

        // if (resource) {
        //     if (this.adalService.userInfo.isAuthenticated) {
        //         authenticatedCall = this.adalService.acquireToken(resource)
        //             .flatMap((token: string) => {
        //                 if (options1.headers == null) {
        //                     options1.headers = new Headers();
        //                 }
        //                 options1.headers.set('Authorization', 'Bearer ' + token);
        //                 return this.http.request(url, options1).pipe(map(this.extractData), tap(null,(error) => this.log(error)));
        //             });
        //     }
        //     else {
        //         authenticatedCall = Observable.throw(new Error('User Not Authenticated.'));
        //     }
        // }
        // else {
        //     authenticatedCall = this.http.request(url, options).pipe(map(this.extractData) /*, catchError(this.handleError)*/ );
        // }
        // return authenticatedCall;
    }

    private extractData(res: Response): any {
        if (res.status < 200 || res.status >= 300) {
            throw new Error('Bad response status: ' + res.status);
        }

        let body = {};
        // if there is some content, parse it
        if (res.status !== 204) {
            body = res.text() ? res.json() : {};
        }
        return body || {};
    }

    // private handleError(error: any) {
    //     return Observable.throw(error);
    // }

    // async server(subscriber = false) {

    //     if (subscriber) {
    //         let info = await this.msalHelperService.server();
    //         var response = await this.httpClient.post("https://prod.flowstudio.app/server", info).toPromise();
    //     }
    //         //debugger;
    //     return;
    // }

    verifyCoupon(coupon: string) {

        var response = this.httpClient.post(`https://prod.flowstudio.app/api/verify`, {
            "coupon": coupon
        }).toPromise();
        return response;
    }

    async getFlowHistory(flow: Flow): Promise<any[]> {

        var user = this.getCurrentUser();

        var token = user.idToken;

        var requestBody = {
            //token: token,
            query: 'definitions',
            environment: flow.environment,
            flow: flow.flowName,
            check: true
        };
        var requestHeaders = {
            token: btoa(JSON.stringify(token))
        };

        var response: any = await this.httpClient.post("https://prod.flowstudio.app/query", requestBody, { headers: requestHeaders }).pipe(map((versions: any[]) => {

            var versions = versions.sort((a, b) => {
                return ('' + b.Name).localeCompare(a.Name);
            });

            var i;
            for (i = 0; i < versions.length; i++) {
                versions[i].VersionNumber = (versions.length - i);
                versions[i].Modified = new Date(versions[i].Name);
            }

            return versions;

        })).toPromise();


        return response;

    }

    async getHistory(flow: Flow, version: string) {
        var user = this.getCurrentUser();

        var token = user.idToken;

        var requestBody = {
            //token: token,
            query: 'definition',
            environment: flow.environment,
            flow: flow.flowName,
            version: version
        };
        var requestHeaders = {
            token: btoa(JSON.stringify(token))
        };

        var response: any = await this.httpClient.post("https://prod.flowstudio.app/query", requestBody, { headers: requestHeaders }).toPromise();


        return response;

    }

    async getUser(userid) {
        const t = this.msalHelperService.getCachedTokenInternal(['user.read']);
        if (!t) {
            return {};
        }
        const { secret:token } = t;
        const headers = {
            'Authorization': `Bearer ${token}`,
        }
        return this.httpClient.get(`https://graph.microsoft.com/beta/users/${userid}`, { headers }).toPromise().then((response: any) => {
            return response;
        });
    }

    async getUserPhoto(userid): Promise<Blob | null> {
        if (!userid) {
            return null;
        }

        const t = this.msalHelperService.getCachedTokenInternal(['user.read']);
        if (!t) {
            return null;
        }
        const { secret:token } = t;
        const headers = {
            'Authorization': `Bearer ${token}`,
        }
        return this.httpClient.get(`https://graph.microsoft.com/beta/users/${userid}/photos/48x48/$value`, { headers, responseType: 'blob' })
            .toPromise()
            .then((response: Blob) => response instanceof Blob ? response : null)
            .catch((error: HttpErrorResponse) => {
                if (error.status === 401 || error.status === 403 || error.status === 404) {
                    return null;
                }

                throw error;
            });

        
    }
    
    async searchFlows(searchText: string) {
        var user = this.getCurrentUser();

        var token = user.idToken;
        var environment = this.currentEnvironment;

        var requestBody = {
            //token: token,
            query: 'search',
            environment: environment,
            searchText: searchText
        };
        var requestHeaders = {
            token: btoa(JSON.stringify(token))
        };

        // let decodeBase64 = function(s) {
        //     var e={},i,b=0,c,x,l=0,a,r='',w=String.fromCharCode,L=s.length;
        //     var A="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        //     for(i=0;i<64;i++){e[A.charAt(i)]=i;}
        //     for(x=0;x<L;x++){
        //         c=e[s.charAt(x)];b=(b<<6)+c;l+=6;
        //         while(l>=8){((a=(b>>>(l-=8))&0xff)||(x<(L-2)))&&(r+=w(a));}
        //     }
        //     return r;
        // };

        let reFlow = /\/definitions\/(.+)\/flows\/(.+)\//gi;
        var response: any = await this.httpClient.post("https://prod.flowstudio.app/search", requestBody, { headers: requestHeaders }).pipe(map((blobs: any[]) => {

            return blobs.map(blob => {

                //let path = decodeBase64(blob.Path);
                let path = blob.Path;
                // /definitions/Default-26e65220-5561-46ef-9783-ce5f20489241/flows/15c0c029-40a6-4b3f-8420-a13e20c6a11a/2019-01-21T14:28:17.1687607Z
                let m = reFlow.exec(path);
                return (m && m[1] == environment) ? m[2] : null;
            }).filter(flowName => {
                return flowName;
            });

        })).toPromise();

        return response;

    }

    private yieldToBrowser(): Promise<void> {
        return new Promise((resolve) => setTimeout(resolve, 0));
    }

    async updateClips(clips: any) {
        return this.updateItems(clips, "clips");
    }

    async updatePlans(plans: any) {
        return this.updateItems(plans, "plans");
    }

    async updateItems(items: any, name: string) {
        const url = `/api/${name}`;

        let user = this.getCurrentUser();
        let token = user.idTokenClaims;
        let blob = {}
        blob[name] = items;

        var requestBody = {
            //token: token,
            method: 'PATCH',
            blob: blob
        };
        var requestHeaders = {
            'X-HTTP-METHOD': "PATCH",
            'X-AUTHENTICATION': btoa(JSON.stringify(token))
        };

        var response: any = await this.httpClient.patch(url, requestBody, { headers: requestHeaders }).toPromise();
        return response;
    }

    async getItems(name: string): Promise<Plan[]> {
        const url = `/api/${name}`;

        var user = this.getCurrentUser();
        var token = user.idTokenClaims;
        var requestBody = {
            //token: token,
            method: 'GET'
        };
        var requestHeaders = {
            'X-HTTP-METHOD': "GET",
            'X-AUTHENTICATION': btoa(JSON.stringify(token))
        };

        let items = await this.httpClient.get(url, { headers: requestHeaders }).pipe(map((res:any)=>{
            return res[name] ? res[name] : [];
        })).toPromise();

        return items;
    }

    async getClips(): Promise<any[]> {
        return this.getItems('clips');
    }

    async getPlans(): Promise<Plan[]> {
        // Hit the local SWA API proxy (registered in api/src/index.ts under 'plans').
        // The proxy forwards to process.env.PLANS_URL → ${FLOWSTUDIO_API}/plans, so
        // this works the same on localhost (dev SWA), prod.flowstudio.app, and
        // dev.flowstudio.app. Calling the cross-origin URL directly trips CORS.
        const url = '/api/plans';

        var user = this.getCurrentUser();
        var token = user.idTokenClaims;

        var requestHeaders = {
            'X-HTTP-METHOD': 'GET',
            'X-AUTHENTICATION': btoa(JSON.stringify(token))
        };

        let storage = [] // await this.storageService.getPlans();

        let server = await this.httpClient.get(url, { headers: requestHeaders }).pipe(map((res:any)=>{
            return res.plans;
        })).toPromise();

        let plans = (server && server.length) ? server : storage;

        if (plans && storage && storage.length > 0) {
            storage.forEach((item:Plan)=>{
                let one = plans.find((i:Plan)=>i.name == item.name);
                if (one == null) {
                    plans.push(item);
                }
            })
            await this.updatePlans(plans);
            //await this.storageService.removePlans();
        }

        return plans;
        //return response;
    }

    async searchFlowsExact(all: Flow[], searchText: string, re: RegExp = null): Promise<Flow[]> {
        //let environment = this.currentEnvironment;
        //var cacheFlows = await this.storageService.getFlows(environment);

        searchText = (searchText || '').toLowerCase();
        const altSearchText = searchText.replace(' ', '_');

        const flows = all.filter(flow => {

            let blob = Object.assign({}, flow, { 'runs': null });

            let code = JSON.stringify(blob);

            if (re) {
                return re.test(code);
            }

            code = code.toLowerCase();

            return code.indexOf(searchText) >= 0 || code.indexOf(altSearchText) >= 0;

            // if (flow.triggerUrl) {
            //     if (flow.triggerUrl.indexOf(searchText)>=0) {
            //         return true;
            //     }
            // }
            // if (flow.definition) {
            //     let code = JSON.stringify(flow.definition, undefined, 2);
            //     if (code.indexOf(searchText)>=0) {
            //         return true;
            //     }
            // }
            // return false;
        })

        return flows;
    }

    async testSharePointDataset(): Promise<any> {

        let url = 'https://service.flow.microsoft.com/';
        // url = 'https://management.azure.com/';
        var scopes = this.msalHelperService.getScopesForEndpoint(url);
        var tokenStored = this.msalHelperService.getCachedTokenInternal(scopes);

        let options = {
            headers: {
                Authorization: `Bearer ${tokenStored.token}`,
            }
        };

        return await this.httpClient.get("https://australia-001.azure-apim.net/apim/sharepointonline/7074430539ef4097bb0646eae5601ca5/datasets", options).toPromise();

        // https://australia-001.azure-apim.net/apim/sharepointonline/7074430539ef4097bb0646eae5601ca5/datasets

        // https://australia-001.azure-apim.net/apim/sharepointonline"7074430539ef4097bb0646eae5601ca5
    }

}

